/* eslint-disable no-console */ /* eslint-disable no-undef */
<template>
  <section class="container-fluid p-0 bodyArea">
    <div class="containerBox">
      <div class="pageHeader devicesPageHeader row m-0 align-items-center">
        <div v-if="$auth.isAuthenticated" class="col-6 row m-0 p-0">
          <div class="deviceStatus totalDevices col">
            Total Devices : {{ deviceStats.total }}
          </div>
          <div class="deviceStatus onlineDevices col">
            Online Devices : {{ deviceStats.online }}
          </div>
          <div class="deviceStatus offlineDevices col">
            Offline Devices : {{ deviceStats.offline }}
          </div>
         
          </div>
          <div class="col text-right">
          <!-- <div v-if="$auth.isAuthenticated" class="filterWrapper">
            <div class="filterText">Tenant :</div>
            <select
              class="form-control dropdown col p-0"
              :required="true"
              @change="fetchDevices"
              id="tenantId"
              v-model="deviceTenant"
            > 
               <option
                class="tenantOption"
                v-for="option in tenants"
                v-bind:key="option.value"
                :value="option.value"
              >
                {{ option.text ? option.text : option.value }}
              </option>
            </select>
          </div> -->

          <!-- <div
            v-if="$auth.isAuthenticated && deviceList != null"
            class="filterWrapper"
          >
            <div class="filterText">Filter:</div>
            <input
              v-model="locationFilter"
              type="text"
              maxlength="20"
              class="filterInputText"
            /> -->
          <!-- <select
            class="form-control dropdown col p-0"
            id="locationFilter"
            @change="onLocationChanged" >
            <option
              class="tenantOption"
              v-for="option in locationList"
              v-bind:key="option"
              v-bind:value="JSON.stringify(option.value)"
              :selected="locationFilter && locationFilter.lid === option.value.lid && locationFilter.uid === option.value.uid && locationFilter.aid===option.value.aid"
            >{{ option.text }}</option>
          </select>-->
          <!-- </div> -->
          <!-- Device Operations -->
          <button id="exportBtn" lastSelectedTenant class="filterWrapper exportBtn"
            @click.prevent="addDeviceOperation($event)" :disabled="!lastSelectedTenant">
            Device Operations
          </button>
          <!-- Add Media Node -->
          <!-- <button id="exportBtn" class="filterWrapper exportBtn" @click.prevent="openMediaNode($event)">
            Add Media Node
          </button> -->
          <button id="exportBtn" class="filterWrapper exportBtn" @click.prevent="exportDevices">
            Export
          </button>
          <button id="ProvisionBtn" class="filterWrapper exportBtn" @click.prevent="onClickProvision">
            Provision
          </button>
          <!-- <button id="btnLoadMore" class="filterWrapper exportBtn" v-if="nextDevicePointer && nextDevicePointer.length > 0"
          @click.prevent="fetchDevices" >Load More</button>-->
          <!--  <button
            id="toastBtn"
            class="filterWrapper exportBtn"
            @click.prevent="toastAlert"
          >Alert</button>-->
        </div>
        </div>
               
        
      </div>
      <div>
      <div class="row row2 m-2" style="padding-top: 10px" >
        <div v-if="$auth.isAuthenticated" class="global-search-container text-right">
                     <div class="disp-f device-search-input">
                       <input class="filterText full " type="text" placeholder=" Enter atleast 3 characters with DeviceId" style="height:40px" id="device-search-global"
                              v-model="searchPannel.enteredDeviceInfo">
                       </div>
                     <button id="deviceSubmitbtn" class="filterWrapper exportBtn" :disabled="searchPannel.enteredDeviceInfo.length<3" @click="fetchDevicesList">Submit</button>
                     <button id="global-search-clear-container" class="filterWrapper exportBtn"  @click="clearSearch">Clear</button>

          </div>
    </div>
    </div>
    <div class="row2">
    <div class="filterDeviceWrapper justify-content-start row">
      <div class="container-fluid ">
        <div class="filterHeader d-flex ">
          <div>
            <div v-if="$auth.isAuthenticated" class="filterWrapper">
              <div class="filterText pad-0">Tenant :</div>
              <model-select v-model="lastSelectedTenantObj" :options="tenants" name="text" id="value"
                placeholder="Select Tenant" class="tenantList" @input="tenantSelectedEvent">
              </model-select>
            </div>
            <!-- <select class="form-control dropdown col p-0 active" :required="true" @change="fetchTenants" id="tenantId"
                      v-model="searchPannel.selectedTenant">
                <option class="tenantOption" v-for="option in tenants" v-bind:key="option.value" :value="option.value">
                  {{ option.text ? option.text : option.value }}
                </option>
              </select> -->
          </div>
          <div>
            <div v-if="$auth.isAuthenticated" class="filterWrapper">
              <div class="filterText">Device Model :</div>
              <select class="form-control dropdown col p-0" :required="true" :disabled="!lastSelectedTenant"
                @change="filterDevices" v-model="searchPannel.selectedDeviceModel"
                v-bind:class="{ active: lastSelectedTenant }" id="modelname">
                <option value="">-SELECT-</option>
                <option value="AMS T2">AMS T2</option>
                <option value="AMS T3">AMS T3</option>
                <option value="AIM M2">AIM M2</option>
                <option value="AIM H1">AIM H1</option>
                <option value="AMS R2W">AMS R2W</option>
                <option value="AMS R2O">AMS R2O</option>
              </select>
            </div>
          </div>
          <div>
            <div v-if="$auth.isAuthenticated" class="filterWrapper">
              <div class="filterText">Device Status :</div>
              <select class="form-control dropdown col p-0" :required="true" :disabled="!lastSelectedTenant"
                @change="filterDevices" v-model="searchPannel.selectedDeviceStatus"
                v-bind:class="{ active: lastSelectedTenant }" id="devicestatus">
                <option value="">-SELECT-</option>
                <option value="OFFLINE">OFFLINE</option>
                <option value="ONLINE">ONLINE</option>
              </select>
            </div>
          </div>
          <div>
            <div v-if="$auth.isAuthenticated" class="filterWrapper">
              <div class="d-flex full">
                <input class="filterText" type="text" placeholder="Facitilty/Unit/Area" style="height: 36px"
                  id="char" v-on:keyup.enter="deviceSerach" v-model="searchPannel.deviceSearch" />
              </div>
            </div>
          </div>
          <div>
            <button type="button" class="filterWrapper normalBtn" @click="deviceSerach">
              Submit
            </button>
            <button type="button" class="filterWrapper normalBtn" @click="clearSearch">
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
    <div >
      <div class="filterHeader d-flex mt-2">
        <div class="filterWrapper">
          <div class="filterText">Facility :</div>
          <div class="dropdown col p-0">
            <model-select v-model="locationSerchTerm" :options="facilityList" name="text" id="value"
              placeholder="Search Facility" @input="updateDeviceList" class="tenantList">
            </model-select>
          </div>
        </div>
        <div class="filterWrapper">
          <div class="filterText">Unit :</div>
          <div class="dropdown col p-0">
            <model-select v-model="unitSerchTerm" :options="unitSearchList" name="text" id="value"
              placeholder="Search Unit" @input="updateDeviceListByUnit" class="tenantList">
            </model-select>
          </div>
        </div>
        <div class="filterWrapper">
          <div class="filterText">Area :</div>
          <div class="dropdown col p-0">
            <model-select v-model="areaSerchTerm" :options="areaSearchList" name="text" id="value"
              placeholder="Search Area" @input="updateDeviceListByArea" class="tenantList">
            </model-select>
          </div>
        </div>
        <div>
        </div>
      </div>
    </div>
    </div>
    <!--    <div class="container-fluid">-->
    <!--      <div class="filterHeader d-flex mt-3">-->
    <!--        <div>-->
    <!--          <div v-if="$auth.isAuthenticated" class="filterWrapper">-->
    <!--            <div class="d-flex full clear-device">-->
    <!--              <input class="filterText" type="text" placeholder="Device Id" style="height: 40px" id="char"-->
    <!--                     v-on:keyup.enter="fetchChar" v-model="searchPannel.enteredDeviceInfo" />-->
    <!--              <span v-if="searchPannel.enteredDeviceInfo" class="clear-icon" v-on:click="clearDeviceSearch">&#10006;</span>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <button id="deviceSubmitbtn" class="filterWrapper exportBtn" :disabled="!searchPannel.enteredDeviceInfo"-->
    <!--                @click="fetchChar">-->
    <!--          Submit-->
    <!--        </button>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="pageDataWrapper">
      <div class="contentHeader row m-0 align-items-center">
        <div class="col">
          <img src="../assets/images/tenantsHeaderIcon.svg" width="16" />&nbsp;Device Id
        </div>
        <div class="col">
          <img src="../assets/images/locationIcon.svg" width="16" />&nbsp;Location
        </div>
        <div class="col">
          <img src="../assets/images/macIcon.svg" width="16" />&nbsp;Mac
          Addresses
        </div>
        <div class="col">
          <img src="../assets/images/IPIcon.svg" width="16" />&nbsp;IP Address
        </div>
        <div class="col">
          <img src="../assets/images/configuration-icon.svg" width="16" />&nbsp;Configuration
        </div>
        <div class="col">
          <label class="checkbox-container">
            Select
            <!--  <input type="checkbox" />
            <span class="checkmark"></span>-->
          </label>
          <div class="dropdown col p-0">
            <!--  <button class="btnExport" id="exportBtn" @click.prevent="exportDevices">Export</button> -->
            <!--  <button class="btnExport"  @click="clearSelection">Clear </button> -->
          </div>
          <div v-if="selectedDevices != null &&
            selectedDevices.length > 0 &&
            selectedDeviceModel != 'AIM H1' &&
            selectedDeviceModel != 'AMS R2W'
            " class="dropdown col p-0">
            <!--  <p v-if="commandError != null  && commandError.length > 0" class="smallFont" style="color:red">* {{commandError}}</p> -->

            <a class="dropdown-toggle actionDropDown" href="javascript:void(0)" role="button" id="actionDropDownLink"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Actions</a>
            <div class="dropdown-menu actionDropDownData dropdown-menu-right" aria-labelledby="actionDropDownLink">
              <!--  <a class="dropdown-item" href="javascript:void(0)">Install App </a>
              <a class="dropdown-item" href="javascript:void(0)">Uninstall App</a>
              <a class="dropdown-item" href="javascript:void(0)">Set Volume
                <input type="text" id="volumeLevel" v-model="volumeLevel" @keypress="isNumber($event)" />
                <button class="importBtn"
                  :disabled="!(volumeLevel && volumeLevel.length > 0 && parseInt(volumeLevel) > 0 && parseInt(volumeLevel)<=100)"
                  @click.prevent="setVolume" style="font-size:0.8em;"
                >Apply</button>
                </a>
              <a class="dropdown-item" href="javascript:void(0)">Show Temps</a>
              <a class="dropdown-item" href="javascript:void(0)">Hide Temps</a>-->

              <!-- CONFIGS -->
              <div class="actionWrapper row m-0">
                <!--   <div class="actionWrapperRow row m-0 col-12">
                  <div class="col-5 actionWrapperRowHeading p-0">Action</div>
                  <div class="col-5 p-0 text-right">
                    <div class="installBtn actionBtn">Install</div>
                    <div class="uninstallBtn actionBtn">Uninstall</div>
                  </div>
                </div>-->
                <div class="actionWrapperRow row m-0 col-12" v-if="selectedDeviceModel === 'AMS T3' ||
                  selectedDeviceModel === 'AMS T2v2'
                  ">
                  <div class="col-7 actionWrapperRowHeading p-0">
                    Set Volume
                  </div>
                  <div class="col-5 p-0 text-right">
                    <input type="tel" class="actionInput actionBtn installBtn" id="volumeLevel" v-model="volumeLevel"
                      @keypress="isNumber($event)" />
                    <div class="actionBtn active uninstallBtn" :disabled="!(
                      volumeLevel &&
                      volumeLevel.length > 0 &&
                      parseInt(volumeLevel) > 0 &&
                      parseInt(volumeLevel) <= 100
                    )
                      " @click.prevent="setVolume">
                      Set
                    </div>
                  </div>
                </div>

                <div class="actionWrapperRow row m-0 col-12" v-if="selectedDeviceModel === 'AMS T3' ||
                  selectedDeviceModel === 'AMS T2v2'
                  ">
                  <div class="col-7 actionWrapperRowHeading p-0">
                    Temperature
                  </div>
                  <div class="col-5 p-0 text-right">
                    <div class="actionBtn installBtn showBtn" @click.prevent="showTemperature">
                      Show
                    </div>
                    <div class="actionBtn uninstallBtn hidebtn" @click.prevent="hideTemperature">
                      Hide
                    </div>
                  </div>
                </div>

                <!-- Safezone -->
                <div class="actionWrapperRow row m-0 col-12" v-if="selectedDeviceModel === 'AIM M2'">
                  <div class="col-7 actionWrapperRowHeading p-0">
                    Auto adjust safezone?
                  </div>
                  <div class="col-5 p-0 text-right">
                    <div class="actionBtn installBtn showBtn" @click.prevent="autoAdjustOn">
                      Yes
                    </div>
                    <div class="actionBtn uninstallBtn hidebtn" @click.prevent="autoAdjustOff">
                      No
                    </div>
                  </div>
                </div>

                <!-- Device Video -->
                <div class="actionWrapperRow row m-0 col-12" v-if="selectedDeviceModel === 'AIM M2'">
                  <div class="col-5 actionWrapperRowHeading p-0">
                    Patient Room Video
                  </div>
                  <div class="col-7 p-0 text-right">
                    <div class="actionBtn clientShowBtn" value="set-printing-settings" @click.prevent="showDeviceVideo">
                      Show
                    </div>
                  </div>
                </div>

                <!-- Getting up audio -->
                <div class="actionWrapperRow row m-0 col-12" v-if="selectedDeviceModel === 'AIM M2'">
                  <div class="col-7 actionWrapperRowHeading p-0">
                    Getting Up Audio Enabled?
                  </div>
                  <div class="col-5 p-0 text-right">
                    <div class="actionBtn installBtn showBtn" @click.prevent="gettingUpAudioOn">
                      Yes
                    </div>
                    <div class="actionBtn uninstallBtn hidebtn" @click.prevent="gettingUpAudioOff">
                      No
                    </div>
                  </div>
                </div>

                <!-- alert_ignoring_others -->
                <div class="actionWrapperRow row m-0 col-12" v-if="selectedDeviceModel === 'AIM M2'">
                  <div class="col-7 actionWrapperRowHeading p-0">
                    Alert Ignoring Others?
                  </div>
                  <div class="col-5 p-0 text-right">
                    <div class="actionBtn installBtn showBtn" @click.prevent="alertIgoreOthersOn">
                      Yes
                    </div>
                    <div class="actionBtn uninstallBtn hidebtn" @click.prevent="alertIgoreOthersOff">
                      No
                    </div>
                  </div>
                </div>

                <!-- alert_ignoring_others -->
                <div class="actionWrapperRow row m-0 col-12" v-if="selectedDeviceModel === 'AMS T3' ||
                  selectedDeviceModel === 'AMS T2v2'
                  ">
                  <div class="col-7 actionWrapperRowHeading p-0">
                    Badge Scanner enabled?
                  </div>
                  <div class="col-5 p-0 text-right">
                    <div class="actionBtn installBtn showBtn" @click.prevent="badgeScannerOn">
                      Yes
                    </div>
                    <div class="actionBtn uninstallBtn hidebtn" @click.prevent="badgeScannerOff">
                      No
                    </div>
                  </div>
                </div>

                <div class="actionWrapperRow row m-0 col-12" v-if="selectedDeviceModel === 'AMS T3' ||
                  selectedDeviceModel === 'AMS T2' ||
                  selectedDeviceModel === 'AMS T2v2'
                  ">
                  <div class="col-5 actionWrapperRowHeading p-0">
                    Client Settings
                  </div>
                  <div class="col-7 p-0 text-right">
                    <div class="actionBtn clientShowBtn" value="set-client-settings" @click.prevent="onChanged">
                      Show
                    </div>
                  </div>
                </div>
                <div class="actionWrapperRow row m-0 col-12" v-if="selectedDeviceModel === 'AMS T2v2'">
                  <div class="col-7 actionWrapperRowHeading p-0">
                    Set NTP Server
                  </div>
                  <!--  <p v-if="sendConfigurationCommand === 'sendNTP'">
            <input type="text" value="" placeholder="server name" id="ntpServerName"/>
            <button v-if="sendConfigurationCommand != null && sendConfigurationCommand.length > 0" @click.prevent="sendNtpCommand" style="font-size:0.8em;">Send NTP Command</button>
                  </p>-->
                  <div class="col-5 p-0 text-right">
                    <input type="text" class="actionInput1 actionBtn installBtn" placeholder="server name"
                      id="ntpServerName" />
                    <div class="actionBtn active uninstallBtn" :disabled="!(
                      volumeLevel &&
                      volumeLevel.length > 0 &&
                      parseInt(volumeLevel) > 0 &&
                      parseInt(volumeLevel) <= 100
                    )
                      " @click.prevent="sendNtpCommand">
                      Set
                    </div>
                  </div>
                </div>
                <!--    <div class="actionWrapperRow row m-0 col-12">
                  <div class="col-7 p-0">Client Settings</div>
                  <div class="col-5 p-0 text-right">
                    <div>
                       <div class="actionBtn showBtn" @click.prevent="onChanged">Show</div>
                      <select @change="onChanged"  v-model="sendConfigurationCommand">
                        <option value>-SELECT COMMAND-</option>
                        <option value="set-temperature-display-settings">Temp Display</option>
                        <option value="set-temperature-thresholds">Temp Threshold</option>
                        <option value="set-general-settings">Enable Verbose Logging</option>
                        <option value="set-client-settings">Client Settings</option>
                        <option value="sendNTP">Set NTP Server</option>
                      </select>
                    </div>
                  </div>
                </div>-->
                <div class="actionWrapperRow row m-0 col-12" v-if="selectedDeviceModel === 'AMS T3' ||
                  selectedDeviceModel === 'AMS T2' ||
                  selectedDeviceModel === 'AMS T2v2'
                  ">
                  <div class="col-5 actionWrapperRowHeading p-0">
                    Manual Check-in
                  </div>
                  <div class="col-7 p-0 text-right">
                    <div class="actionBtn clientShowBtn" value="set-client-settings"
                      @click.prevent="showVisitorProperties">
                      Show
                    </div>
                  </div>
                </div>
                <div class="actionWrapperRow row m-0 col-12" v-if="selectedDeviceModel === 'AMS T3' ||
                  selectedDeviceModel === 'AMS T2' ||
                  selectedDeviceModel === 'AMS T2v2'
                  ">
                  <div class="col-5 actionWrapperRowHeading p-0">Printing</div>
                  <div class="col-7 p-0 text-right">
                    <div class="actionBtn clientShowBtn" value="set-printing-settings" @click.prevent="showPrinting">
                      Show
                    </div>
                  </div>
                </div>

                <div class="actionWrapperRow row m-0 col-12" v-if="selectedDeviceModel === 'AMS R2O'">
                  <div class="col-7 actionWrapperRowHeading p-0">Reset</div>
                  <div class="col-5 p-0 text-right">
                    <div class="actionBtn installBtn showBtn one" @click.prevent="reset">
                      Yes
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="contentDataWrapper deviceDataWrapper row m-0">
        <h3 v-if="listEmpty">No results Found</h3>
        <div v-for="device in deviceList" v-bind:key="device.deviceId"
          class="contentData row m-0 align-items-center col-12 p-0">
          <div class="col row m-0 align-items-center">
            <div class="col-12 p-0 deviceName text-truncate-ellipsis" :title="device.deviceId + ' ' + device.model">
              <span  v-html="device.deviceId"></span>&nbsp;
             {{ device.model }}
            </div>
            <div class="col-12 p-0">
              <img v-if="device.status === 'ONLINE'" src="../assets/images/wifiIcon-green.svg" width="16" />
              <img v-if="device.status === 'OFFLINE'" src="../assets/images/wifiIcon.svg" width="16" />
              <img v-if="device.status !== 'ONLINE' && device.status !== 'OFFLINE'"
                src="../assets/images/wifiIcon-gray.svg" width="16" />
              <!-- <span v-html="getDeviceStatus(device)"></span> -->
              <span>&nbsp;{{ device.currentActiveConnection }}</span>
            </div>
          </div>
          <div class="col" :title="device.taxonomy_name" v-html="device.taxonomy_name"></div>
          <div class="col">
            <div class="col row m-0 p-0 align-items-center">
              <div class="col-12 p-0 deviceName">
                {{
                device.eth0 && device.eth0.mac ? "E: " + device.eth0.mac : ""
                }}
              </div>
              <div class="col-12 p-0">
                <span>{{
                  device.wlan0 && device.wlan0.mac
                  ? "W: " + device.wlan0.mac
                  : ""
                  }}</span>
              </div>
            </div>
            <!--  <span>{{device.eth0?"E: "+device.eth0.mac:""}}</span>
            <span>{{device.wlan0?"W: "+device.wlan0.mac:""}}</span>-->
          </div>
          <div class="col">
            <div class="col row m-0 p-0 align-items-center">
              <div class="col-12 p-0 deviceName">
                {{
                device.eth0 && device.eth0.address
                ? "E: " + device.eth0.address
                : ""
                }}
              </div>
              <div class="col-12 p-0">
                <span>{{
                  device.wlan0 && device.wlan0.address
                  ? "W: " + device.wlan0.address
                  : ""
                  }}</span>
              </div>
            </div>
            <!--  <span>{{device.eth0?"E: "+device.eth0.mac:""}}</span>
            <span>{{device.wlan0?"W: "+device.wlan0.mac:""}}</span>-->
          </div>
          <div class="col row m-0 align-items-center">
            <div class="col-12 p-0 deviceName">
              <span>Version -</span>
              {{ device.firmware ? device.firmware.version : "--" }}
            </div>
            <div class="col-12 p-0 deviceName noBorder">
              <span>Volume -</span>..
              <span>Temp -</span>
              {{
              device.configuration
              ? device.configuration.display_temperature
              : "--"
              }}
            </div>
          </div>
          <div class="col row m-0 align-items-center">
            <div class="col-12 p-0 row m-0">
              <label class="checkbox-container col-5">
                Select
                <input type="checkbox" hidden @click="
                  check(device, $event.target.checked, clearSelectedItems)
                  " v-bind:key="device.deviceId" :disabled="(device.model === 'AMS T3' ||
    device.model === 'AMS T2' ||
    device.model === 'AMS R2O' ||
    device.model === 'AMS R2W' ||
    device.model === 'AMS T2v2' ||
    device.model === 'AIM E1' ||
    device.model === 'AIM R1' ||
    device.model === 'AIM R2' ||
    device.model === 'AIM M2') &&
    (selectedDeviceModel === '' ||
      selectedDeviceModel === device.model)
    ? false
    : true
    " :value="device.deviceId" v-model="selectedDevices" />
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="additionalInfo" v-if="selectedDeviceAction === 'setVolume' && device.selected == true
              ">
              <input type="text" id="volumeLevel" v-model="volumeLevel" @keypress="isNumber($event)" />
              <button class="importBtn" :disabled="!(
                volumeLevel &&
                volumeLevel.length > 0 &&
                parseInt(volumeLevel) > 0 &&
                parseInt(volumeLevel) <= 100
              )
                " @click.prevent="setVolume" style="font-size: 0.8em">
                Apply
              </button>
            </div>
            <div class="additionalInfo smallFont" v-if="selectedDeviceAction.indexOf('Temperature') > 0 &&
              device.selected == true
              ">
              <button class="importBtn m-0" v-if="selectedDeviceAction === 'showTemperature'"
                @click.prevent="showTemperature" style="font-size: 0.8em">
                Apply
              </button>
              <button class="importBtn m-0" v-if="selectedDeviceAction === 'hideTemperature'"
                @click.prevent="hideTemperature" style="font-size: 0.8em">
                Apply
              </button>
            </div>

            <!--  <div class="additionalInfo" v-html="showSelectedDevices()"></div> -->
          </div>
        </div>
      </div>
      <!--  <button class="btn btn--primary mx-auto" @click="openModal()">Open modal</button> -->
    </div>
    <!-- </div> -->

    <b-modal v-model="showProvisionDevicesDialog" id="provisionModal" hide-backdrop centered title="Device Provision"
      @cancel="showProvisionDevicesDialog = false">
      <b-container>
        <div class="requestCol">
          <b-tabs content-class="mt-2">
            <b-tab title="Manual Entry">
              <div class="mt-2 provisionCol">
                <b-container class="provisionCol">
                  <label class="m-0">
                    Provision Sensor
                  </label>
                </b-container>
                <b-col class="m-0 p-0" style="border-width: 1px; border-color: black">
                  <b-row class="compactFilterWrapper">
                    <label>Tenant</label>

                    <!-- <select
                      class="provisionDropdown"
                      v-model="deviceProvisionDocument.Tenant"
                    >
                      <option
                        v-for="option in tenants"
                        v-bind:key="option.value"
                        :value="option.value"
                      >
                        {{ option.text ? option.text : option.value }}
                      </option>
                    </select> -->
                    
                    <model-select :options="tenants" v-model="provisionTenantObj" name="text" id="value"
                      placeholder="Please select a tenant" @input="validateProvisionTenantSelection" class="tenantList"
                      >
                    </model-select>
                  </b-row>
                  <!-- <b-row style="justify-content: center">
                    <label class="m-1" style="padding: 15px">Device Type</label>
                    <select
                      class="provisionDropdown"
                      v-model="deviceProvisionDocument.DeviceType"
                    >
                      <option>AIM H1</option>
                      <option>AIM M2</option>
                      <option>AIM R2O</option>
                      <option>AIM R2W</option>
                      <option>AIM T2V2</option>
                    </select>
                  </b-row> -->
                  <b-row>
                    <label>Sensor Id</label>
                    <input
                      v-model="deviceProvisionDocument.SensorId" type="text" placeholder="Sensor Id" class="text" />
                  </b-row>
                  
                  <!-- <b-row style="justify-content: center">
                    <label class="m-1" style="padding: 15px">Expires</label>
                    <Datepicker
                      v-model="dateValue"
                      placeholder="Date"
                      style="width: 200px; height: 40px; margin-top: 15px"
                    >
                    </Datepicker>
                  </b-row> -->

                  <button id="ProvisionSubmitBtn" class="filterWrapper exportBtn mt-2"
                    @click.prevent="onSubmitProvision">
                    Provision
                  </button>

                  <button id="ProvisionSubmitBtn" class="filterWrapper exportBtn mt-2"
                    @click.prevent="closeProvisionModal">
                    Cancel
                  </button>
                </b-col>
              </div>
            </b-tab>
            <b-tab title="Import CSV">
              <div>
                <div class="mt-2 provisionCol" style="justify-content: center">
                  <b-container class="provisionCol">
                    <label class="m-0">
                      Provision Sensor
                    </label>
                  </b-container>
                  <b-row class="compactFilterWrapper">
                    <label>Tenant</label>

                    <!-- <select
                      class="provisionDropdown"
                      v-model="deviceProvisionDocument.Tenant"
                      style="width: auto;"
                    >
                      <option
                        v-for="option in tenants"
                        v-bind:key="option.value"
                        :value="option.value"
                      >
                        {{ option.text ? option.text : option.value }}
                      </option>
                    </select> -->
                    <model-select :options="tenants" v-model="provisionTenantObj" name="text" id="value"
                      placeholder="Please select a tenant" @input="validateProvisionTenantSelection"
                      >
                    </model-select>
                  </b-row>
                  <!-- <b-row style="justify-content: center">
                    <label class="m-1" style="padding: 15px">Expires</label>
                    <Datepicker
                      v-model="importCsvDateValue"
                      placeholder="Date"
                      style="width: 200px; height: 40px; margin-top: 15px"
                    >
                    </Datepicker>
                  </b-row> -->
                  <div class="buttonItem" type="file" id="csvFileInput" @click.prevent="showFileImportScreen" accept=".csv">
                    Browse
                  </div>
                  <div class="mt-3 mb-2" style="
                      width: 100%;
                      max-height: 300px;
                      border-radius: 5px;
                      border: 1px solid #ebebeb;
                      padding: 5px;
                      justify-content: center;
                      overflow-y: scroll;
                    ">
                    <input type="file" hidden style="display: none" id="fileInput" @change="handleFiles"
                      accept=".csv" />
                    <table width="100%" style="align-self: center;">
                      <tr v-if="importedDeviceIds != null &&
                        importedDeviceIds.length > 0
                        ">
                        <td colspan="1">
                          <table width="100%" class="tableDataWrapper m-0 p-2">
                            <tr class="contentHeader align-items-center">
                              <td>Device Id</td>
                            </tr>
                            <tr :class="importedDeviceIds.isValid
                              ? 'contentRow'
                              : 'contentRow error'
                              " v-for="importedDeviceId in importedDeviceIds" v-bind:key="importedDeviceId">
                              <td>{{ importedDeviceId["DeviceId"] }}</td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <button id="ProvisionSubmitBtn" class="filterWrapper exportBtn mt-2"
                    @click.prevent="onSubmitProvision">
                    Provision
                  </button>

                  <button id="ProvisionSubmitBtn" class="filterWrapper exportBtn mt-2"
                    @click.prevent="closeProvisionModal">
                    Cancel
                  </button>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </b-container>
    </b-modal>

    <b-modal v-model="showEventCreationDialog" id="myModal" hide-backdrop centered title="Client Settings"
      ok-title="Push Config" @ok="sendFullClientSettings" @hidden="showEventCreationDialog = false"
      @cancel="showEventCreationDialog = false">
      <b-form ref="form">
        <b-form-group id="input-group-4">
          <label class="checkbox-container">
            Activate Questionnaire
            <input type="checkbox" id="cbxActivateQuestionnaire"
              v-model="sendConfigurationDocument.is_covid_questionnaire_enabled" />
            <span class="checkmark"></span>
          </label>
          <label class="checkbox-container">
            Bypass ID Validation
            <input type="checkbox" id="cbxBypassValidation" v-model="sendConfigurationDocument.bypass_id_validation" />
            <span class="checkmark"></span>
          </label>
          <label class="checkbox-container">
            Show QR Scan
            <input type="checkbox" id="cbxShowQRCodeScanner"
              v-model="sendConfigurationDocument.covid_questionnaire_qr_enabled" />
            <span class="checkmark"></span>
          </label>

          <!-- <b-form-checkbox id="cbxActivateQuestionnaire" value="cbxActivateQuestionnaire"  v-model="sendConfigurationDocument.is_covid_questionnaire_enabled" >Activate Questionnaire</b-form-checkbox>
          <b-form-checkbox id="cbxBypassValidation" v-model="sendConfigurationDocument.bypass_id_validation" value="cbxBypassValidation">Bypass ID Validation</b-form-checkbox>
          <b-form-checkbox id="cbxShowQRCodeScanner" v-model="sendConfigurationDocument.covid_questionnaire_qr_enabled" value="cbxShowQRCodeScanner">Show QR Scan</b-form-checkbox>-->
        </b-form-group>
        <b-form-group label="Main Tout">
          <b-form-input id="tbxAnsMsg1" v-model="sendConfigurationDocument.covid_questionnaire_msg_1"
            value="If the answer is 'YES' to any of the below questions, please exit the facility and contact your supervisor."></b-form-input>
        </b-form-group>
        <b-form-group label="Question 1">
          <b-form-input id="tbxQuestion1" v-model="sendConfigurationDocument.covid_questionnaire_question_1"
            value="Do you have any of the following symptoms?"></b-form-input>
        </b-form-group>
        <b-form-group label="Question 1 info">
          <b-form-textarea id="tbxQuestionSub" v-model="sendConfigurationDocument.covid_questionnaire_question_1_sub
            "
            value="u25CF Congestion / runny nose\n\u25CF Chills (with or without repeated shaking)\n\u25CF Recent or current shortness of breath\n\u25CF Cough\n\u25CF Headache\n\u25CF Muscle pain / body aches\n\u25CF New loss of taste or smell\n\u25CF New onset of gastrointestinal symptoms, nausea, vomiting, or diarrhea\n\u25CF Sore throat\n\u25CF Fatigue\n\u25CF Fever, 100° F or higher in the last 24 hours"></b-form-textarea>
        </b-form-group>
        <b-form-group label="Question 2">
          <b-form-input id="tbxQuestion2" v-model="sendConfigurationDocument.covid_questionnaire_question_2"
            value="Have you been currently asked to quarantine due to COVID positive exposure?"></b-form-input>
        </b-form-group>
        <b-form-group label="Message 2">
          <b-form-input id="tbxAnsMsg2" v-model="sendConfigurationDocument.covid_questionnaire_msg_2"
            value="If the answer to the above questions is 'NO', or if you have been cleared by employee health, scan your QR code."></b-form-input>
        </b-form-group>
        <b-form-group label="Question Size">
          <b-form-input id="tbxQSize" type="number" v-model.number="sendConfigurationDocument.covid_questionnaire_questions_size
            " value="25"></b-form-input>
        </b-form-group>
        <b-form-group label="Message Size">
          <b-form-input id="tbxMSize" type="number" v-model.number="sendConfigurationDocument.covid_questionnaire_messages_size
            " value="30"></b-form-input>
        </b-form-group>
        <b-form-group label="Scan Line Width">
          <b-form-input id="tbxSLW" type="number" v-model.number="sendConfigurationDocument.covid_questionnaire_scanning_line_width
            " value="280"></b-form-input>
        </b-form-group>
        <b-form-group label="Scan Line Height">
          <b-form-input id="tbxSLH" type="number" v-model.number="sendConfigurationDocument.covid_questionnaire_scanning_line_height
            " value="355"></b-form-input>
        </b-form-group>
      </b-form>
    </b-modal>

    <b-modal id="visitorPropertiesModal" hide-backdrop size="xl" centered
      class="visitorModalClass" title="Manual Check-In Configuration." ok-title="Update" @ok="updateVisitorProperties"
      @hidden="showVisitorPropertiesDialog = false" @cancel="showVisitorPropertiesDialog = false">
      <b-container>
        <table width="100%">
          <tr class="visit-headings">
            <td>mapping</td>
            <td>Question</td>
            <td>Placeholder</td>
            <td>Default Value</td>
            <td>Select</td>
          </tr>
          <tr v-for="option in manualCheckIn" v-bind:key="option.mapping">
            <td class="mapping">
              <select class="selectDD" @change="onMappingChanged($event, f)" v-model="option.mapping">
                <option v-for="optionObj in mappingList" v-bind:key="optionObj.value" :value="optionObj.value">
                  {{ optionObj.text ? optionObj.text : optionObj.value }}
                </option>
              </select>
            </td>
            <td class="question">
              <input v-model="option.question" type="text" />
            </td>
            <td>
              <input v-model="option.placeholder" type="text" />
            </td>
            <td>
              <input v-model="option.defaultValue" type="text" />
            </td>
            <td>
              <label class="checkbox-container">
                Select
                <input type="checkbox" v-model="option.isChecked" />
                <span class="checkmark"></span>
              </label>

              <!-- <select v-model="option.inputType">
                <option value="text">text</option>
                <option value="number">number</option>
                <option value="phone">phone</option>
                <option value="email">email</option>
                <option value="password">password</option>
                <option value="checkbox">checkbox</option>
              </select> -->
            </td>
          </tr>
        </table>
      </b-container>
    </b-modal>
    <b-modal v-model="showPrintCreationDialog" id="myPrintingModal" hide-backdrop centered title="Printing"
      ok-title="Push Config" @ok="sendPrintingSettings" @hidden="showPrintCreationDialog = false"
      @cancel="showPrintCreationDialog = false">
      <b-form ref="form">
        <b-form-group id="input-group-4">
          <label class="checkbox-container">
            Is Printing Enabled
            <input type="checkbox" id="printEnableFlag" v-model="sendPrintingDocument.is_printing_enabled" />
            <span class="checkmark"></span>
          </label>
        </b-form-group>
        <b-form-group label="Printing Port">
          <b-form-select id="printingPort" selected value="" v-model="sendPrintingDocument.printing_port"
            :options="printing_port">
          </b-form-select>
        </b-form-group>
        <b-form-group id="input-group-4">
          <label class="checkbox-container">
            Display Printer Error Message Screen
            <input type="checkbox" id="printerErrorFlag" v-model="sendPrintingDocument.display_printer_error_message_screen
              " />
            <span class="checkmark"></span>
          </label>
        </b-form-group>
        <b-form-group id="input-group-4">
          <label class="checkbox-container">
            Is Header Row1 Enabled
            <input type="checkbox" id="headerEnableFlag" v-model="sendPrintingDocument.is_header_row1_enabled" />
            <span class="checkmark"></span>
          </label>
        </b-form-group>
        <b-form-group label="Header Row Text">
          <b-form-input id="headerRowText" v-model="sendPrintingDocument.header_row1_text"></b-form-input>
        </b-form-group>
        <b-form-group label="Header Row1 Size">
          <b-form-input id="headerRow1Size" type="number"
            v-model.number="sendPrintingDocument.header_row1_size"></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-4">
          <label class="checkbox-container">
            Is Header Row2 Enabled
            <input type="checkbox" id="isHeaderRow2Enabled" v-model="sendPrintingDocument.is_header_row2_enabled" />
            <span class="checkmark"></span>
          </label>
        </b-form-group>
        <b-form-group label="Header Row2 Text">
          <b-form-input id="headerRow2Text" type="checkbox"
            v-model.number="sendPrintingDocument.header_row2_text"></b-form-input>
        </b-form-group>
        <b-form-group label="Header Row2 Size">
          <b-form-input id="headerRow2Size" type="number"
            v-model.number="sendPrintingDocument.header_row2_size"></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-4">
          <label class="checkbox-container">
            Is Middle Row1 Enabled
            <input type="checkbox" id="isMiddleRow1Enabled" v-model="sendPrintingDocument.is_middle_row1_enabled" />
            <span class="checkmark"></span>
          </label>
        </b-form-group>
        <b-form-group label="Middle Row1 Text">
          <b-form-input id="middleRow1Text" v-model.number="sendPrintingDocument.middle_row1_text"></b-form-input>
        </b-form-group>
        <b-form-group label="Middle Row1 Size">
          <b-form-input id="middleRow1Size" type="number"
            v-model.number="sendPrintingDocument.middle_row1_size"></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-4">
          <label class="checkbox-container">
            Is Middle Row2 Enabled
            <input type="checkbox" id="isMiddleRow2Enabled" v-model="sendPrintingDocument.is_middle_row2_enabled" />
            <span class="checkmark"></span>
          </label>
        </b-form-group>
        <b-form-group label="Middle Row2 Text">
          <b-form-input id="middleRow2Text" v-model.number="sendPrintingDocument.middle_row2_text"></b-form-input>
        </b-form-group>
        <b-form-group label="Middle Row2 Size">
          <b-form-input id="middleRow2Size" type="number"
            v-model.number="sendPrintingDocument.middle_row2_size"></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-4">
          <label class="checkbox-container">
            Is Footer Row1 Enabled
            <input type="checkbox" id="isFooterRow1Enabled" v-model="sendPrintingDocument.is_footer_row1_enabled" />
            <span class="checkmark"></span>
          </label>
        </b-form-group>
        <b-form-group id="input-group-4">
          <label class="checkbox-container">
            Is Footer Row2 Enabled
            <input type="checkbox" id="isFooterRow2Enabled" v-model="sendPrintingDocument.is_footer_row2_enabled" />
            <span class="checkmark"></span>
          </label>
        </b-form-group>
        <b-form-group id="input-group-4">
          <label class="checkbox-container">
            Is Picture Enabled
            <input type="checkbox" id="isPictureEnabled" v-model="sendPrintingDocument.is_picture_enabled" />
            <span class="checkmark"></span>
          </label>
        </b-form-group>
        <b-form-group id="input-group-4">
          <label class="checkbox-container">
            Is Trademark Name Enabled
            <input type="checkbox" id="isTrademarkNameEnabled"
              v-model="sendPrintingDocument.is_trademark_name_enabled" />
            <span class="checkmark"></span>
          </label>
        </b-form-group>
        <b-form-group label="Error Screen Text">
          <b-form-input id="errorScreenText" v-model.number="sendPrintingDocument.error_screen_text"></b-form-input>
        </b-form-group>
        <b-form-group label="Error Screen Text Size">
          <b-form-input type="number" id="errorScreenTextSize"
            v-model.number="sendPrintingDocument.error_screen_text_size"></b-form-input>
        </b-form-group>
        <b-form-group label="Error Message Display Time">
          <b-form-input id="errorMessageDisplayTime" type="number"
            v-model.number="sendPrintingDocument.error_message_display_time"></b-form-input>
        </b-form-group>
        <!-- <b-form-group label="Is Display Qrcode Enabled">
            <b-form-input
            id="isDisplayQrcodeEnabled"
            type="boolean"
            v-model.number="sendPrintingDocument.is_display_qrcode_enabled"
          ></b-form-input>
         </b-form-group> -->
        <b-form-group id="input-group-4">
          <label class="checkbox-container">
            Is Display Qrcode Enabled
            <input type="checkbox" id="isDisplayQrcodeEnabled"
              v-model="sendPrintingDocument.is_display_qrcode_enabled" />
            <span class="checkmark"></span>
          </label>
        </b-form-group>

        <b-form-group label="Error Time In Printing Queue">
          <b-form-input id="errorTimeInPrintingQueue" type="number"
            v-model.number="sendPrintingDocument.time_in_printing_queue"></b-form-input>
        </b-form-group>
      </b-form>
    </b-modal>
    <b-modal v-model="showM2DeviceVideo" ref="m2DeviceVideo" id="m2DeviceVideo" hide-backdrop size="xl" centered
      class="deviceVideo" title="Device Video" ok-only ok-variant="secondary" ok-title="Close" :static="true"
      @cancel="closePatientDeviceVideo" @hidden="closePatientDeviceVideo">
      <b-container>
        <div class="col row align-items-center">
          <div class="col-12 p-0 deviceVideo align-items-center">
            <video ref="videojs" id="videojs" class="player video-js vjs-default-skin" preload="none"
              style="width: 600px; height: 500px"></video>
            <!--            <video-player ref="videoPlayer"-->
            <!--                          id="videoPlayer"-->
            <!--                          class="vjs-custom-skin"-->
            <!--                          :options="playerOptions"-->
            <!--                          @play="onPlayerPlay($event)"-->
            <!--                          @ready="onPlayerReady($event)">-->
            <!--            </video-player>-->
          </div>
        </div>
      </b-container>
    </b-modal>

    <!-- add media node model starts -->
    <b-modal id="addModal" hide-backdrop centered title="Add Media Node" title-class="test" ok-title="Save"
      @ok="addMediaNode" @hidden="clearModal" @cancel="clearModal">
      <b-form ref="form">
        <!--  key control -->
        <b-form-group label="Key *" label-for="key" invalid-feedback="Please enter a key.">
          <b-form-input id="key" v-model="addMediaNodeObj.Key" placeholder="key"></b-form-input>
        </b-form-group>
        <!--  URL   control -->
        <b-form-group label="URL *" label-for="url" invalid-feedback="Please enter URL.">
          <b-form-input id="url" v-model="addMediaNodeObj.url" placeholder="URL"></b-form-input>
        </b-form-group>
        <b-form-group>
          <!-- Recurraning check control -->
          <b-form-checkbox id="checkbox-recurring" v-model.bool="addMediaNodeObj.staticPin" name="staticPin"
            unchecked-value="false" value="true" inline>
            Is Static Pin ?
          </b-form-checkbox>
        </b-form-group>
        <!--  URL   control -->
        <b-form-group label="Token *" label-for="token" invalid-feedback="Please enter token.">
          <b-form-input id="token" v-model="addMediaNodeObj.token " placeholder="token"></b-form-input>
        </b-form-group>
        <!-- nodeFilter  -->
        <b-form-group label="Node Filter *" label-for="nodeFilter" invalid-feedback="Please enter node filter.">
          <b-form-input id="nodeFilter" v-model="addMediaNodeObj.nodeFilter " placeholder="Node Filter"></b-form-input>
        </b-form-group>
        <!-- proxyNodeFilter  -->
        <b-form-group label="Node Filter *" label-for="proxyNodeFilter"
          invalid-feedback="Please enter proxy node filter.">
          <b-form-input id="proxyNodeFilter" v-model="addMediaNodeObj.nodeFilter "
            placeholder="Proxy Node Filter"></b-form-input>
        </b-form-group>
        <b-form-group label="Pexip SDK Version" label-for="pexipSDKVersion"
          invalid-feedback="Please select pexip SDK version.">
          <b-form-select id="pexipSDKVersion" class="languageWrapperSelect" v-model="addMediaNodeObj.pexipSDKVersion"
            style="width: 100%">
            <option class="w-75" v-for="option in pexipSDKVersionOptionArray" v-bind:key="option.value" :value="option">
              {{ option.text }}
            </option>
          </b-form-select>
        </b-form-group>

      </b-form>
    </b-modal>


    <!-- showDeviceOperations  -->
    <!-- closeDeviceOprtaionModal -->

    <b-modal id="addDeviceOperationsModal" hide-backdrop centered title="Add Device Operations" title-class="test"
      ok-title="Next" ok-disabled @hidden="closeDeviceOprtaionModal" @cancel="closeDeviceOprtaionModal">
      <b-form ref="form">
        <!--  step ===1 -->
        <b-form-group label="Job Type" label-for="job_type" invalid-feedback="Please select job type."
          v-if="deviceOpsStep===1">
          <b-form-select id="job_type" class="jobType" v-model="deviceOperationsObj.job_type" style="width: 100%">
            <option class="w-75" v-for="option in jobTypeArray" v-bind:key="option.value" :value="option">
              {{ option.text }}
            </option>
          </b-form-select>
        </b-form-group>
        <!-- step===2 -->
        <b-form-group label="Job Name" label-for="job_name" invalid-feedback="Please select job name."
          v-if="deviceOpsStep===2">
          <b-form-select id="job_name" class="jobName" v-model="deviceOperationsObj.job_name" style="width: 100%">
            <option class="w-75" v-for="option in jobNameArray" v-bind:key="option.value" :value="option">
              {{ option.text }}
            </option>
          </b-form-select>
        </b-form-group>
        <b-form-group label="Job Version" label-for="job_version" invalid-feedback="Please select job version."
          v-if="deviceOpsStep===2">
          <b-form-select id="job_version" class="jobVersion" v-model="deviceOperationsObj.job_version"
            style="width: 100%">
            <option class="w-75" v-for="option in jobVersionArray" v-bind:key="option.value" :value="option">
              {{ option.text }}
            </option>
          </b-form-select>
        </b-form-group>

        <!-- step===3 -->
        <b-form-group label="Facility" label-for="facility" invalid-feedback="Please select facility."
          v-if="deviceOpsStep===3">
          <b-form-select id="facility" class="facility" v-model="deviceOperationsObj.facility" style="width: 100%" @input="onFacilityChange">
            <option class="w-75" v-for="option in facilityListDeviceObj" v-bind:key="option.id" :value="option.text">
              {{ option.text }}
            </option>
          </b-form-select>
        </b-form-group>
        <b-form-group label="Location" label-for="location" invalid-feedback="Please select location."
          v-if="deviceOpsStep===3">
          <b-form-select id="location" class="location" v-model="deviceOperationsObj.location" style="width: 100%" @change="onLocationChange">
            <option class="w-75" v-for="option in unitListDeviceObj" v-bind:key="option.id" :value="option.text">
              {{ option.text }}
            </option>
          </b-form-select>
        </b-form-group>

        <b-form-group label="Area" label-for="area" invalid-feedback="Please select area." v-if="deviceOpsStep===3">
          <b-form-select id="area" class="area" v-model="deviceOperationsObj.area" style="width: 100%">
            <option class="w-75" v-for="option in areaListDeviceObj" v-bind:key="option.id" :value="option.text">
              {{ option.text }}
            </option>
          </b-form-select>
        </b-form-group>
        <!-- step===4 -->
        <b-form-group label="Start Date" label-for="start_date" invalid-feedback="Please select start date."
          v-if="deviceOpsStep===4">
            <Datepicker id="start_date" v-model="startDateRange" placeholder="Date" @change="onDateChange('start_date')">
                  </Datepicker>
                  <p v-if="deviceOperationsObj.start_date == ''" style="color: red; margin-left: 10px; margin-top: 10px">
                    Enter a valid Date
                  </p>
        </b-form-group>
        <b-form-group label="End Date" label-for="end_date" invalid-feedback="Please select end date."
          v-if="deviceOpsStep === 4">
          <Datepicker id="end_date" v-model="endDateRange" placeholder="Date" @change="onDateChange('end_date')">
                  </Datepicker>
                  <p v-if="deviceOperationsObj.end_date == ''" style="color: red; margin-left: 10px; margin-top: 10px">
                    Enter a valid Date
                  </p>
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="success" @click="saveDeviceOperations" v-if="deviceOpsStep < 4">
          Next
        </b-button>
        <b-button size="sm" variant="success" @click="saveDeviceOperations" v-if="deviceOpsStep === 4">
          Create
        </b-button>
        <!-- <b-button size="sm" variant="danger" @click="closeDeviceOprtaionModal()">
          Cancel
        </b-button> -->

      </template>

    </b-modal>

  </section>
</template>
<script>
// import {videoPlayer} from 'vue-videojs7';
// import videojs from "video.js";
import Vue from "vue";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import Datepicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'

Vue.use(VueToast);
Vue.use(Loading);

export default {
  // components: {
  //   videoPlayer
  // },
  // computed: {
  //   player() {
  //     return this.$refs.videoPlayer.player;
  //   }
  // },
  name: "Devices",
  components: { Datepicker, ModelSelect },
  data() {
    return {
      searchPannel: {
        selectedTenant: "",
        selectedDeviceModel: "",
        selectedDeviceStatus: "",
        enteredDeviceInfo: "",
        deviceSearch: "",
      },
      devicesForCommand: [{ text: "-SELECT-" }],
      loading: true,
      counts: 0,
      next: "",
      showEventCreationDialog: false,
      showProvisionDevicesDialog: false,
      showVisitorPropertiesDialog: false,
      showPrintCreationDialog: false,
      clearSelectedItems: false,
      showM2DeviceVideo: false,
      deviceVideoStreamURL: "",
      deviceTenant: "",
      hideFacilityDropDown: true,
      playerOptions: {
        autoplay: true,
        controls: true,
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
        },
      },
      player: null,
      errorMessage: "Loading...",
      deviceStats: { online: 0, offline: 0, total: 0 },
      tenantsList: [],
      tenants: [{ text: "-SELECT-", value: "" }],
      deviceList: [],
      deviceListTemp: [],
      singleDevice: [],
      nextDevicePointer: [],
      lastSelectedTenantObj: "",
      lastSelectedTenant: "",
      provisionTenant: "",
      provisionTenantObj: "",
      locationList: [],
      facilityListDeviceObj: [],
      unitListDeviceObj: [],
      areaListDeviceObj: [],
      areaList: [],
      devicesMessage: "",
      devices: [],
      locationFilter: null,
      selectedDeviceModel: "",
      selectedDevices: [],
      tag: "",
      importedDeviceIds: [],
      importedLoadingMessage: "",
      printing_port: [
        { value: "USB", text: "USB" },
        { value: "BLUETOOTH", text: "BLUETOOTH" },
      ],
      tags: [],
      selectedDeviceAction: "",
      volumeLevel: 0,
      commandError: "",
      show: false,
      sendConfigurationCommand: "",
      dateValue: "",
      importCsvDateValue: "",
      sendPrintingDocument: {
        is_printing_enabled: true,
        printing_port: this.printing_port ? this.printing_port : "USB",
        display_printer_error_message_screen: false,
        is_header_row1_enabled: true,
        header_row1_text: "name",
        header_row1_size: 20,
        is_header_row2_enabled: true,
        header_row2_text: "companyName",
        header_row2_size: 20,
        is_middle_row1_enabled: true,
        middle_row1_text: "DEFAULT",
        middle_row1_size: 20,
        is_middle_row2_enabled: true,
        middle_row2_text: "DEFAULT",
        middle_row2_size: 20,
        is_footer_row1_enabled: true,
        is_footer_row2_enabled: true,
        is_picture_enabled: true,
        is_trademark_name_enabled: true,
        error_screen_text: "DEFAULT",
        error_screen_text_size: 45,
        error_message_display_time: 0,
        is_display_qrcode_enabled: false,
        time_in_printing_queue: 20000,
      },
      sendConfigurationDocument: {
        is_covid_questionnaire_enabled: true,
        covid_questionnaire_screen_time: 10000,
        text_invalid_qr_code_msg: "default",
        covid_questionnaire_question_1:
          "Do you have any of the following symptoms?",
        covid_questionnaire_question_1_sub:
          "\u25CF Congestion / runny nose\n\u25CF Chills (with or without repeated shaking)\n\u25CF Recent or current shortness of breath\n\u25CF Cough\n\u25CF Headache\n\u25CF Muscle pain / body aches\n\u25CF New loss of taste or smell\n\u25CF New onset of gastrointestinal symptoms, nausea, vomiting, or diarrhea\n\u25CF Sore throat\n\u25CF Fatigue\n\u25CF Fever, 100° F or higher in the last 24 hours",
        covid_questionnaire_question_2:
          "Have you been currently asked to quarantine due to COVID positive exposure?",
        covid_questionnaire_msg_1:
          "If the answer is 'YES' to any of the below questions, please exit the facility and contact your supervisor.",
        covid_questionnaire_msg_2:
          "If the answer to the above questions is 'NO', or if you have been cleared by employee health, scan your QR code.",
        covid_questionnaire_questions_size: 25,
        covid_questionnaire_messages_size: 30,
        covid_questionnaire_scanning_line_width: 280,
        covid_questionnaire_scanning_line_height: 355,
        bypass_id_validation: false,
        covid_questionnaire_qr_enabled: true,
      },
      deviceProvisionDocument: {
        Tenant: "",
        DeviceType: "",
        SensorId: "",
        Expires: "",
      },
      manualCheckIn: [
        {
          mapping: "visitorInfo|full_name|first",
          question: "What is your first name?",
          placeholder: "First name",
          defaultValue: "Nate",
          inputType: "text",
          isChecked: true,
        },
        {
          mapping: "visitorInfo|full_name|last",
          question: "What is your last name?",
          placeholder: "Last Name",
          inputType: "text",
          isChecked: true,
        },
        {
          mapping: "visitorInfo|companyName",
          question: "What is your company name?",
          placeholder: "Company Name",
          inputType: "text",
          isChecked: true,
        },
        {
          mapping: "visitorInfo|visitingWith",
          question: "Who are you visiting?",
          placeholder: "Joe Anyone",
          inputType: "text",
          isChecked: true,
        },
        {
          question: "What is your phone number?",
          placeholder: "(999)999-9999",
          inputType: "phone",
          mapping: "visitorInfo|phoneNumber",
          isChecked: true,
        },
        {
          question: "Are you vaccinated for covid?",
          placeholder: "Covid Vaccine",
          defaultValue: false,
          inputType: "checkbox",
          mapping: "visitorInfo|covidVaccine",
          isChecked: true,
        },
        {
          mapping: "visitorInfo|userType",
          inputType: "hidden",
          defaultValue: "IDENTITY.VISITOR",
          isChecked: true,
        },
        {
          mapping: "visitorInfo|screeningSurvey|status",
          inputType: "hidden",
          defaultValue: "NEGATIVE",
          isChecked: true,
        },
      ],
      mappingList: [
        // { text: "-SELECT-", value: "" },
        { text: "Visitor - First Name", value: "visitorInfo|full_name|first" },
        { text: "Visitor - Last Name", value: "visitorInfo|full_name|last" },
        { text: "Company Name", value: "visitorInfo|companyName" },
        { text: "Visiting With", value: "visitorInfo|visitingWith" },
        { text: "Phone Number", value: "visitorInfo|phoneNumber" },
        { text: "Vaccinated for COVID", value: "visitorInfo|covidVaccine" },
        { text: "User Type", value: "visitorInfo|userType" },
        {
          text: "Screening Survey",
          value: "visitorInfo|screeningSurvey|status",
        },
      ],
      locationSerchTerm: '',
      unitSerchTerm: '',
      areaSerchTerm: '',
      locationSearchList:[],
      unitSearchList:[],
      areaSearchList:[],
      pexipSDKVersionOptionArray:[
        {text:'V30_1',value:'V30_1'},
        {text:'v26.2',value:'V26_2'},
      ],
      addMediaNodeObj:{},
      deviceOperationsObj:{},
      deviceOpsStep:0,
      okTitleDeviceOps:"Next",
      unitDeviceOpsList:[],
      areaDeviceOpsList:[],
      jobTypeArray:[
        {text:'Install',value:'install'},
        {text:'UnInstall',value:'uninstall'},
        {text:'Reboot',value:'reboot'}

      ],
      jobNameArray:[
        {text:'care.ai Call App',value:'care.ai_call_App'},
        {text:'care.ai IMP App',value:'care.ai_imp_App'},
        {text:'Ambiant Monitoring',value:'ambiant_monitoring'}
      ],
      jobVersionArray:[
        {text:'1.50.0.1',value:'1.50.0.1'},
        {text:'1.50.0.9',value:'1.50.0.9'},
        {text:'1.50.0.6.2',value:'1.50.0.6.2'},
        {text:'1.50.0.6',value:'1.50.0.6'}
      ],
      startDateRange:"",
      endDateRange:"",
      listEmpty:false,
      facilityList: [{text:'Select Facility', value:''}],
      unitDeviceData:[]

    };
  },

  mounted() {
    this.fetchData();
    $("input").attr("autocomplete", "off");
  },

  methods: {
    closeModal() {
      this.show = false;
    },
    openModal() {
      this.lastSelectedTenant;
      this.show = true;
      this.$bvModal.show("myModal");
    },
    onSubmitProvision() {
      this.deviceProvisionDocument.Expires = this.dateValue;
      this.provisionDevices();
      this.showProvisionDevicesDialog = false;
    },
    closeProvisionModal() {
      this.clearProvisionData();
      this.showProvisionDevicesDialog = false;
    },
    clearProvisionData() {
      this.provisionTenantObj = "";
      this.deviceProvisionDocument = {
        Tenant: "",
        DeviceType: "",
        SensorId: "",
        Expires: "",
      };
      this.importedDeviceIds = [];
    },
    clearSelection() {
      this.selectedDevices = [];
      this.selectedDeviceAction = "";
      this.sendConfigurationCommand = "";
      this.commandError = "";
      this.deviceList.forEach((e) => {
        e.selected = false;
      });
      this.sendConfigurationDocument = {
        is_covid_questionnaire_enabled: true,
        covid_questionnaire_screen_time: 10000,
        text_invalid_qr_code_msg: "default",
        covid_questionnaire_question_1:
          "Do you have any of the following symptoms?",
        covid_questionnaire_question_1_sub:
          "\u25CF Congestion / runny nose\n\u25CF Chills (with or without repeated shaking)\n\u25CF Recent or current shortness of breath\n\u25CF Cough\n\u25CF Headache\n\u25CF Muscle pain / body aches\n\u25CF New loss of taste or smell\n\u25CF New onset of gastrointestinal symptoms, nausea, vomiting, or diarrhea\n\u25CF Sore throat\n\u25CF Fatigue\n\u25CF Fever, 100° F or higher in the last 24 hours",
        covid_questionnaire_question_2:
          "Have you been currently asked to quarantine due to COVID positive exposure?",
        covid_questionnaire_msg_1:
          "If the answer is 'YES' to any of the below questions, please exit the facility and contact your supervisor.",
        covid_questionnaire_msg_2:
          "If the answer to the above questions is 'NO', or if you have been cleared by employee health, scan your QR code.",
        covid_questionnaire_questions_size: 25,
        covid_questionnaire_messages_size: 30,
        covid_questionnaire_scanning_line_width: 280,
        covid_questionnaire_scanning_line_height: 355,
        bypass_id_validation: false,
        covid_questionnaire_qr_enabled: true,
      };
      this.sendPrintingDocument = {
        is_printing_enabled: true,
        printing_port: [
          { text: "USB", value: "USB" },
          { text: "BLUETOOTH", value: "BLUETOOTH" },
        ],
        display_printer_error_message_screen: false,
        is_header_row1_enabled: true,
        header_row1_size: 20,
        is_header_row2_enabled: true,
        header_row2_text: "companyName",
        header_row2_size: 20,
        is_middle_row1_enabled: true,
        middle_row1_text: "DEFAULT",
        middle_row1_size: 20,
        is_middle_row2_enabled: true,
        middle_row2_text: "DEFAULT",
        middle_row2_size: 20,
        is_footer_row1_enabled: true,
        is_footer_row2_enabled: true,
        is_picture_enabled: true,
        is_trademark_name_enabled: true,
        error_screen_text: "DEFAULT",
        error_screen_text_size: 45,
        error_message_display_time: 0,
        is_display_qrcode_enabled: false,
        time_in_printing_queue: 20000,
      };
    },
    async fetchTenants() {
      await this.fetchLocations(this.lastSelectedTenant);
      await this.getDevices();
    },
    updateDeviceList() {
      let locationMatch
      if (this.locationSerchTerm && this.locationSerchTerm !== '') {
        this.unitSearchList=[];
        this.areaSearchList=[];
        this.updateUnitList();
        return this.deviceList = this.deviceListTemp.filter(item => {
          locationMatch = item.location.toLowerCase().includes(this.locationSerchTerm.toLowerCase());
          this.searchPannel.selectedDeviceModel='';
          this.searchPannel.selectedDeviceStatus='';
          return locationMatch
        });
      }
    },
    onFacilityChange(){
      let locationMatch;
      this.unitListDeviceObj=[];
      this.unitDeviceData=[];
      if(this.deviceOperationsObj.facility && this.deviceOperationsObj.facility!==''){
      this.unitDeviceData=locationMatch = this.deviceListTemp.filter(item => {
        if(item.location_name && item.location_name !== null)
        return (item.location_name || '').toLowerCase().includes(this.deviceOperationsObj.facility.toLowerCase());
       });
      this.unitListDeviceObj = this.uniqueArray(locationMatch.map(item => ({ text: item.unit_name, value: item.unit })));
      
      }
    },
    onLocationChange() {
      let list = [];
      if (this.deviceOperationsObj.facility && this.deviceOperationsObj.location) {
        const unitQ = (this.deviceOperationsObj.unit || '').toLowerCase();
        const data = Array.isArray(this.unitDeviceData) ? this.unitDeviceData : [];
        list = data.filter(item =>
          ((item.unit_name || '').toLowerCase()).includes(unitQ)
        );
      }

      this.areaListDeviceObj = this.uniqueArray(list.map(item => ({ text: item.area_name, value: item.area }))
  );
},
    updateAreaList() {
      let list = [];
      if (this.locationSerchTerm && this.locationSerchTerm !== '' && this.unitSerchTerm && this.unitSerchTerm !== '') {
        list = this.deviceListTemp.filter(item => item.location.toLowerCase().includes(this.locationSerchTerm.toLowerCase()) && item.unit.toLowerCase().includes(this.unitSerchTerm.toLowerCase()));
      }
      this.areaSearchList = this.uniqueArray(list.map(item => ({ text: item.area_name, value: item.area })));
      this.areaSearchList=this.areaSearchList.sort(function (a, b) {
          var nameA = a.text;
          var nameB = b.text;
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
    },
    updateUnitList() {
      let locationMatch;
      locationMatch = this.deviceListTemp.filter(item => item.location.toLowerCase().includes(this.locationSerchTerm.toLowerCase()));
      if (locationMatch.length > 0) {
        this.unitSearchList = this.uniqueArray(locationMatch.map(item => ({ text: item.unit_name, value: item.unit })));
        this.unitSearchList = this.unitSearchList.sort(function (a, b) {
          var nameA = a.text; // ignore upper and lowercase
          var nameB = b.text; // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
      }
    },
    updateDeviceListByUnit() {
      if (this.locationSerchTerm && this.locationSerchTerm !== '' && this.unitSerchTerm && this.unitSerchTerm !== '') {
        this.areaSearchList=[];
        this.updateAreaList();
        return this.deviceList = this.deviceListTemp.filter(item => item.location.toLowerCase().includes(this.locationSerchTerm.toLowerCase()) && item.unit.toLowerCase().includes(this.unitSerchTerm.toLowerCase()));
      }
    },
    updateDeviceListByArea() {
      if (this.locationSerchTerm && this.locationSerchTerm !== '' && this.unitSerchTerm && this.unitSerchTerm !== '' && this.areaSerchTerm && this.areaSerchTerm !== '') {
        return this.deviceList = this.deviceListTemp.filter(item => item.location.toLowerCase().includes(this.locationSerchTerm.toLowerCase()) && item.unit.toLowerCase().includes(this.unitSerchTerm.toLowerCase()) && item.area.toLowerCase().includes(this.areaSerchTerm.toLowerCase()));
      }
      
    },
    tenantSelectedEvent() {
      this.lastSelectedTenant = this.getTenantId(this.lastSelectedTenantObj);
      this.searchPannel.selectedTenant = this.lastSelectedTenant;
      this.fetchTenants();
      this.locationSerchTerm = '';
      this.unitSerchTerm = '';
      this.areaSerchTerm = '';
      this.searchPannel.selectedDeviceModel="";
      this.searchPannel.selectedDeviceStatus=""

    },
    validateProvisionTenantSelection() {
      this.provisionTenant = this.getTenantId(this.provisionTenantObj);
      this.deviceProvisionDocument.Tenant = this.provisionTenant;
    },
    getTenantId(Obj) {
      let objVal = this.tenants.find(e => e.value == Obj);
      if (objVal) {
        return objVal.id
      }
      else {
        return ""
      }
    },
    getDropdownValues(tenant) {
      return this.tenantsList.filter((e) => e.value == tenant || e.text == tenant);
    },
    async clearSearch(event) {
      this.searchPannel.enteredDeviceInfo = "";
      this.searchPannel.selectedDeviceModel = "";
      this.searchPannel.selectedDeviceStatus = "";
      this.searchPannel.selectedTenant = "";
      this.searchPannel.enteredDeviceInfo = "";
      this.searchPannel.deviceSearch = "";
      this.unitSerchTerm = "";
      this.areaSerchTerm = "";
      this.locationSerchTerm = "";
      this.lastSelectedTenantObj=""
      if(event.target.id=="global-search-clear-container"){
        this.deviceList=[];
      }
      else
      this.deviceList = this.deviceListTemp
    },
    async filterDevices() {
      this.listEmpty=false
      // this.searchPannel.selectedDeviceModel and this.searchPannel.selectedDeviceStatus are defined
      if (this.searchPannel.selectedDeviceModel && this.searchPannel.selectedDeviceStatus) {
        this.deviceList = this.deviceListTemp.filter(
          (d) => (d.model === this.searchPannel.selectedDeviceModel &&  d.status === this.searchPannel.selectedDeviceStatus)
        );
      }
      //if selectedDeviceModel is not selected
      if (this.searchPannel.selectedDeviceStatus && this.searchPannel.selectedDeviceModel=='') {
        this.deviceList = this.deviceListTemp.filter(
          (d) => d.status === this.searchPannel.selectedDeviceStatus
        );
      }

      //if selectedDeviceStatus is not selected
      if (this.searchPannel.selectedDeviceModel && this.searchPannel.selectedDeviceStatus=='') {
        this.deviceList = this.deviceListTemp.filter(
          (d) => d.model === this.searchPannel.selectedDeviceModel
        );
      }
      //if both are unselected from drop down
      if (this.searchPannel.selectedDeviceModel=='' && this.searchPannel.selectedDeviceStatus=='') {
        this.deviceList = this.deviceListTemp;
      }
        if(this.deviceList.length==0){
          this.listEmpty=true
        }
        else{
          this.listEmpty=false
        }
    },

    async getDevices() {
      let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots",
      });
      this.listEmpty=false;
      this.deviceList = [];
      this.deviceListTemp = [];
      if (this.searchPannel.selectedTenant) {
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        let deviceList = [];
        let requestLimitOffset = "limit=500&offset=0";
        while (requestLimitOffset) {
          var url =
            config.SENSOR_SERVICE +
            `/tenants/${this.searchPannel.selectedTenant}/devices?${requestLimitOffset}`;
          var fetch_model = new Request(url, {
            method: "GET",
            mode: "cors",
            cache: "default",
            withCredentials: true,
            headers: {
              Authorization: "Bearer " + id_token,
              "Content-Type": "application/json",
            },
          });
          try {
            var fetchmodel = await fetch(fetch_model);
            if (fetchmodel.status === 200) {
              var response = await fetchmodel.json();
              this.deviceStats.total=response.count;
              deviceList = deviceList.concat(response.devices);
              requestLimitOffset = response.next;
            }
            if (response.status == 503) {
              return this.getDevices();
            }
          } catch (error) {
            console.error(error);
            requestLimitOffset = null;
            loader.hide();
          }
        }
        this.sortDevicesList(deviceList)
        loader.hide();
      }
      loader.hide();
      if(this.deviceList.length==0){
        this.listEmpty=true
      }
      else{
        this.listEmpty=false
      }
    },
    //processing the unique array by removing the duplicate location,units and areas from it
    uniqueArray(originalArray) {
      let uniqueArray = originalArray.filter((obj, index, self) => {
        return index === self.findIndex((t) => (
          t.text === obj.text && t.value === obj.value
        ));
      });
      return uniqueArray;
    },

    async fetchDeviceId() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var devicename = document.getElementById("devicename").value;
      var url =
        config.SENSOR_SERVICE + `/tenants/${devicename}/devices?limit=50`;
      var fetch_deviceId = new Request(url, {
        method: "GET",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var response = await fetch(fetch_deviceId);
        if (response.status == 503) {
          return this.fetchDeviceId();
        }
        this.devices = response;
      } catch (error) {
        console.error(error);
      }
    },
    async deviceSerach() {
      if (this.deviceListTemp && this.deviceListTemp.length > 0) {
        if (this.searchPannel.deviceSearch) {
          const deviceList = this.deviceListTemp;
          const filteredDevices = deviceList.filter(
            (data) =>
              JSON.stringify(data)
                .toLowerCase()
                .indexOf(this.searchPannel.deviceSearch.toLowerCase()) !== -1
          );
          this.deviceList = filteredDevices;
        } else {
          this.deviceList = this.deviceListTemp;
        }
      } else {
        Vue.$toast.open({
          message:
            "Device search could be done only on devices selected for a specific tenant",
          type: "error",
        });
      }
    },
    clearDeviceSearch(){
      this.searchPannel.enteredDeviceInfo='';
      this.deviceList=this.deviceListTemp;
    },
    async fetchChar() {
      let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots",
      });
      if (this.searchPannel.enteredDeviceInfo) {
        // let matchIndex = this.deviceList.findIndex(a => a.deviceId === this.searchPannel.enteredDeviceInfo)
        // if (matchIndex != -1) {
        //   this.deviceList = this.deviceListTemp.filter(x => x.deviceId === this.searchPannel.enteredDeviceInfo);
        //   Vue.$toast.open({ message: "Data fetched for deviceID : " + this.searchPannel.enteredDeviceInfo, type: "success" });
        //   loader.hide();
        // } else {
        //   Vue.$toast.open({ message: "Please enter a valid deviceId or check the existing filters.", type: "warning" });
        //   loader.hide();
        // }
        this.deviceList = this.deviceListTemp.filter((d) => d.deviceId && d.deviceId.indexOf(this.searchPannel.enteredDeviceInfo))
      } else {
        this.deviceList = this.deviceListTemp;
      }
    },
    async reset() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.SENSOR_SERVICE_V2 +
        `/tenants/${this.lastSelectedTenant}/devices/push-configuration`;
      var resetR2O = new Request(url, {
        method: "POST",
        credentials: "include",
        cache: "default",
        body: JSON.stringify({
          devices: this.selectedDevices,
          document: {
            command: "reset-app-settings",
            data: { calibration_time: 5000 },
          },
        }),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var reset2O = await fetch(resetR2O);
        if (reset2O.status == 503) {
          return this.reset();
        }
      } catch (err) {
        console.error(err);
      }
    },
    async provisionDevices() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var devicesForCommand = this.importedDeviceIds.map(function (d) {
        return d.DeviceId.includes("cai:", 0) == true
          ? d.DeviceId
          : "cai:" + d.DeviceId;
      });
      var url = config.SENSOR_SERVICE + `/tenants/${this.deviceProvisionDocument.Tenant}/sr-int01`;
      var provisionDevicesForTenant = new Request(url, {
        method: "POST",
        credentials: "include",
        cache: "default",
        body: JSON.stringify(
          this.importedDeviceIds.length == 0 ? [this.deviceProvisionDocument.SensorId.includes("cai:", 0) == true
                ? this.deviceProvisionDocument.SensorId
                : "cai:" + this.deviceProvisionDocument.SensorId,
            ]
            : devicesForCommand
        ),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var provisiondDevices = await fetch(provisionDevicesForTenant);
        if (provisiondDevices.status == 503) {
          return this.provisionDevices();
        }
        if (provisiondDevices.status === 200) {
          Vue.$toast.open({ message: "Device provisioned successfully", type: "success" });
        } else if (provisiondDevices.status === 403) {
          Vue.$toast.open({ message: "Do not have permission to provision the device. Please check with Administrator.", type: "error" });
        } else {
          Vue.$toast.open({ message: "Device provisioning failed. Please check with Administrator.", type: "error" });
        }
        this.clearProvisionData();
      } catch (err) {
        console.error(err);
      }
    },
    async sendPrintingSettings() {
      this.selectedDeviceAction = "";
      this.sendConfigurationCommand = "";
      var document = { command: "set-printing-settings" };
      document.data = this.sendPrintingDocument;
      await this.sendIoTJob(document);
    },
    async sendFullClientSettings() {
      this.selectedDeviceAction = "";
      this.sendConfigurationCommand = "";
      var document = { command: "set-client-settings" };

      document.data = this.sendConfigurationDocument;

      document.data.covid_questionnaire_question_1;

      if (
        this.sendConfigurationDocument
          .covid_questionnaire_scanning_line_width <= 0 ||
        this.sendConfigurationDocument
          .covid_questionnaire_scanning_line_height <= 0 ||
        this.sendConfigurationDocument.covid_questionnaire_questions_size <=
        0 ||
        this.sendConfigurationDocument.covid_questionnaire_messages_size <= 0
      ) {
        alert(
          "Invalid numeric value detected. Will not send anything to device."
        );
        return;
      }
      await this.updateQuestionnarie(document.data);
      await this.sendIoTJob(document);
    },
    async mappingElement(element, obj, label) {
      if (element[label] && element[label] != "") {
        obj[label] = element[label];
      }
    },
    async updateVisitorProperties() {
      let manual_check_inData = [];
      this.manualCheckIn.forEach((element) => {
        let obj = {};
        this.mappingElement(element, obj, "mapping");
        this.mappingElement(element, obj, "question");
        this.mappingElement(element, obj, "placeholder");
        this.mappingElement(element, obj, "defaultValue");
        this.mappingElement(element, obj, "inputType");
        // if (element.mapping && element.mapping != "") {
        //   obj["mapping"] = element.mapping;
        // }
        // if (element.question && element.question != "") {
        //   obj["question"] = element.question;
        // }
        // if (element.placeholder && element.placeholder != "") {
        //   obj["placeholder"] = element.placeholder;
        // }
        // if (element.defaultValue && element.defaultValue != "") {
        //   obj["defaultValue"] = element.defaultValue;
        // }
        // if (element.inputType && element.inputType != "") {
        //   obj["inputType"] = element.inputType;
        // }
        if (element.isChecked == true) {
          manual_check_inData.push(obj);
        }
      });
      // let data = {

      // };
      // console.log("Visitor Properties", data);

      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.SENSOR_SERVICE_V2 +
        `/tenants/${this.lastSelectedTenant}/devices/push-configuration`;
      var tenants_list_request = new Request(url, {
        method: "POST",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        body: JSON.stringify({
          devices: this.selectedDevices,
          document: {
            command: "set-visitor-settings",
            data: {
              manual_check_in: manual_check_inData,
            },
          },
        }),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var tenantListResponse = await fetch(tenants_list_request);

        if (tenantListResponse.status === 403) {
          this.errorMessage =
            "Uh oh... You don't have the permission required to access this resource";

          Vue.$toast.open({ message: this.errorMessage, type: "error" });
          return;
        }
        if (tenantListResponse.status == 401) {
          this.errorMessage =
            "Your session has expired please login again to continue";
          Vue.$toast.open({ message: this.errorMessage, type: "error" });
          return;
        }
        if (tenantListResponse.status == 503) {
          return this.updateVisitorProperties();
        }
        if (tenantListResponse.status != 200) {
          this.commandError = "Failed to run " + command.command;
          Vue.$toast.open({ message: this.commandError, type: "error" });
        } else {
          // var tenantsBody = await tenantListResponse.json();

          this.commandError = "";
          Vue.$toast.open({
            message: "Successfully enqueued command ",
            type: "success",
          });
        }
      } catch (tex) {
        this.commandError =
          "Failed to " + command.command + " due to an error.";
        Vue.$toast.open({ message: this.commandError, type: "error" });
      }
    },
    async showTemperature() {
      this.selectedDeviceAction = "";
      this.sendConfigurationCommand = "";
      await this.sendConfiguration("set-temperature-display-settings", {
        display_temperature: true,
      });
      // this.fetchDevices();
    },
    async hideTemperature() {
      this.selectedDeviceAction = "";
      await this.sendConfiguration("set-temperature-display-settings", {
        display_temperature: false,
      });
      //  this.fetchDevices();
      this.fetchDevices();
    },

    async autoAdjustOn() {
      this.selectedDeviceAction = "";
      this.sendConfigurationCommand = "";

      var doc = {
        operation: "update-app-config",
        command: "update-app-config",
        name: "fall-prevention",
        iniFile: "configs/app_config.ini",
        createNew: "no",
        updateStr: "[safezone_autoadjust_config]\nenabled = true",
      };

      // document.data = this.sendPrintingDocument;
      await this.sendIoTJob(doc);

      this.clearSelection();
      this.deviceList = [];
      this.deviceListTemp = [];
      this.fetchDevices();
    },

    async autoAdjustOff() {
      this.selectedDeviceAction = "";
      this.sendConfigurationCommand = "";

      var doc = {
        operation: "update-app-config",
        command: "update-app-config",
        name: "fall-prevention",
        iniFile: "configs/app_config.ini",
        createNew: "no",
        updateStr: "[safezone_autoadjust_config]\nenabled = false",
      };

      // document.data = this.sendPrintingDocument;
      await this.sendIoTJob(doc);

      this.clearSelection();
      this.deviceList = [];
      this.deviceListTemp = [];
      this.fetchDevices();
    },

    async gettingUpAudioOn() {
      this.selectedDeviceAction = "";
      this.sendConfigurationCommand = "";

      var doc = {
        operation: "update-app-config",
        command: "update-app-config",
        name: "fall-prevention",
        iniFile: "configs/app_config.ini",
        createNew: "no",
        updateStr: "[audio]\ngetting_up_audio_enabled = true",
      };

      // document.data = this.sendPrintingDocument;
      await this.sendIoTJob(doc);

      this.clearSelection();
      this.deviceList = [];
      this.deviceListTemp = [];
      this.fetchDevices();
    },

    async gettingUpAudioOff() {
      this.selectedDeviceAction = "";
      this.sendConfigurationCommand = "";

      var doc = {
        operation: "update-app-config",
        command: "update-app-config",
        name: "fall-prevention",
        iniFile: "configs/app_config.ini",
        createNew: "no",
        updateStr: "[audio]\ngetting_up_audio_enabled = false",
      };

      // document.data = this.sendPrintingDocument;
      await this.sendIoTJob(doc);

      this.clearSelection();
      this.deviceList = [];
      this.deviceListTemp = [];
      this.fetchDevices();
    },

    async alertIgoreOthersOn() {
      this.selectedDeviceAction = "";
      this.sendConfigurationCommand = "";

      var doc = {
        operation: "update-app-config",
        command: "update-app-config",
        name: "fall-prevention",
        iniFile: "configs/app_config.ini",
        createNew: "no",
        updateStr: "[demo]\nalert_ignoring_others = true",
      };

      // document.data = this.sendPrintingDocument;
      await this.sendIoTJob(doc);

      this.clearSelection();
      this.deviceList = [];
      this.deviceListTemp = [];
      this.fetchDevices();
    },
    async alertIgoreOthersOff() {
      this.selectedDeviceAction = "";
      this.sendConfigurationCommand = "";

      var doc = {
        operation: "update-app-config",
        command: "update-app-config",
        name: "fall-prevention",
        iniFile: "configs/app_config.ini",
        createNew: "no",
        updateStr: "[demo]\nalert_ignoring_others = false",
      };

      // document.data = this.sendPrintingDocument;
      await this.sendIoTJob(doc);

      this.clearSelection();
      this.deviceList = [];
      this.deviceListTemp = [];
      this.fetchDevices();
    },

    async badgeScannerOn() {
      this.selectedDeviceAction = "";
      this.sendConfigurationCommand = "";

      var doc = {
        operation: "update-app-config",
        command: "update-app-config",
        name: "fall-prevention",
        iniFile: "configs/app_config.ini",
        createNew: "no",
        updateStr: "[badge_scanner]\nenabled = true",
      };

      // document.data = this.sendPrintingDocument;
      await this.sendIoTJob(doc);

      // this.clearSelection();
      // this.deviceList = [];
      // this.deviceListTemp = [];
      // this.fetchDevices();
    },
    async badgeScannerOff() {
      this.selectedDeviceAction = "";
      this.sendConfigurationCommand = "";

      var doc = {
        operation: "update-app-config",
        command: "update-app-config",
        name: "fall-prevention",
        iniFile: "configs/app_config.ini",
        createNew: "no",
        updateStr: "[badge_scanner]\nenabled = false",
      };

      // document.data = this.sendPrintingDocument;
      await this.sendIoTJob(doc);

      // this.clearSelection();
      // this.deviceList = [];
      // this.deviceListTemp = [];
      // this.fetchDevices();
    },

    async setVolume() {
      this.selectedDeviceAction = "";
      this.sendConfigurationCommand = "";
      if (
        this.volumeLevel > 0 &&
        this.volumeLevel <= 100 &&
        this.selectedDevices &&
        this.selectedDevices.length > 0
      ) {
        await this.sendCommand("setVolume", this.volumeLevel, null);
        this.clearSelection();
      }
    },
    ensureDevicesOfSameType(devs) {
      if (devs.length === 1) {
        return true;
      }
      let lastModel = null;
      for (let dId of devs) {
        let d = this.deviceList.find((d) => d.deviceId === dId);
        if (!lastModel) {
          lastModel = d.model;
        } else if (d.model != lastModel) {
          if (
            d.model &&
            d.model.indexOf("AMS T2") >= 0 &&
            lastModel &&
            lastModel.indexOf("AMS T2") >= 0
          ) {
            return true;
          }
          return false;
        }
      }
      return true;
    },
    async updateQuestionnarie(command) {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.COVID_SURVEY +
        `/updateQuestionnaireTemplete?tenants=${this.lastSelectedTenant}`;
      var questionnarie_request = new Request(url, {
        method: "PUT",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        body: JSON.stringify({
          question1: command.covid_questionnaire_question_1,
          question1_sub: command.covid_questionnaire_question_1_sub,
          question2: command.covid_questionnaire_question_2,
        }),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var questionnarieResponse = await fetch(questionnarie_request);
        if (questionnarieResponse.status === 403) {
          this.errorMessage =
            "Uh oh... You don't have the permission required to access this resource";

          Vue.$toast.open({ message: this.errorMessage, type: "error" });
          return;
        }
        if (questionnarieResponse.status == 401) {
          this.errorMessage =
            "Your session has expired please login again to continue";
          Vue.$toast.open({ message: this.errorMessage, type: "error" });
          return;
        }
        if (questionnarieResponse.status == 503) {
          return this.updateQuestionnarie(command);
        }
        if (questionnarieResponse.status != 200) {
          this.commandError = "Failed to run " + command;
          Vue.$toast.open({ message: this.commandError, type: "error" });
        } else {
          var questionnarieBody = await questionnarieResponse.json();

          this.commandError = "";
          Vue.$toast.open({
            message: "Successfully updated questionnarie: " + command,
            type: "success",
          });
        }
      } catch (tex) {
        this.commandError = "Failed to " + command + " due to an error.";
        Vue.$toast.open({ message: this.commandError, type: "error" });
      }
    },
    async sendIoTJob(command, args, when) {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var devicesForCommand = this.selectedDevices.map(function (d) {
        return d.split("+")[0];
      });
      if (!this.ensureDevicesOfSameType(devicesForCommand)) {
        alert(
          "You are mixing different models here. Please ensure that selected devices are of same model to perform this action."
        );
        return;
      }
      var url =
        config.SENSOR_SERVICE_V2 +
        `/tenants/${this.lastSelectedTenant}/devices/push-configuration`;
      var tenants_list_request = new Request(url, {
        method: "POST",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        body: JSON.stringify({
          devices: devicesForCommand,
          document: command,
        }),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var tenantListResponse = await fetch(tenants_list_request);
        if (tenantListResponse.status === 403) {
          this.errorMessage =
            "Uh oh... You don't have the permission required to access this resource";

          Vue.$toast.open({ message: this.errorMessage, type: "error" });
          return;
        }
        if (tenantListResponse.status == 401) {
          this.errorMessage =
            "Your session has expired please login again to continue";
          Vue.$toast.open({ message: this.errorMessage, type: "error" });
          return;
        }
        if (tenantListResponse.status == 503) {
          return this.sendIoTJob(command, args, when);
        }
        if (tenantListResponse.status != 200) {
          this.commandError = "Failed to run " + command.command;
          Vue.$toast.open({ message: this.commandError, type: "error" });
        } else {
          var tenantsBody = await tenantListResponse.json();

          this.commandError = "";
          Vue.$toast.open({
            message: "Successfully enqueued command: " + command.command,
            type: "success",
          });
        }
      } catch (tex) {
        this.commandError =
          "Failed to " + command.command + " due to an error.";
        Vue.$toast.open({ message: this.commandError, type: "error" });
      }
    },
    async sendCommand(command, args, when) {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var devicesForCommand = this.selectedDevices.map(function (d) {
        return d.split("+")[0];
      });
      if (!this.ensureDevicesOfSameType(devicesForCommand)) {
        //alert("You are mixing different models here. Please ensure that selected devices are of same model to perform this action.");
        Vue.$toast.open({
          message:
            "You are mixing different models here. Please ensure that selected devices are of same model to perform this action.",
          type: "info",
        });
        return;
      }
      var url =
        config.SENSOR_SERVICE +
        `/tenants/${this.lastSelectedTenant}/manage-devices/run-command/${command}`;
      // var url = `https://care-ai-app-dot-sensor-api-dot-fifth-name-244415.ue.r.appspot.com/tenants/${this.lastSelectedTenant}/manage-devices/run-command/${command}`;
      var tenants_list_request = new Request(url, {
        method: "POST",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        body: JSON.stringify({
          devices: devicesForCommand,
          when: when,
          args: args,
        }),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var tenantListResponse = await fetch(tenants_list_request);
        if (tenantListResponse.status === 403) {
          this.errorMessage =
            "Uh oh... You don't have the permission required to access this resource";

          Vue.$toast.open({ message: this.errorMessage, type: "error" });

          return;
        }
        if (tenantListResponse.status == 401) {
          this.errorMessage =
            "Your session has expired please login again to continue";
          Vue.$toast.open({ message: this.errorMessage, type: "error" });

          return;
        }
        if (tenantListResponse.status == 503) {
          return this.sendCommand(command, args, when);
        }
        if (tenantListResponse.status != 200) {
          this.commandError = "Failed to run " + command;
          Vue.$toast.open({ message: this.commandError, type: "error" });
        } else {
          var tenantsBody = await tenantListResponse.json();
          this.commandError = "";
          Vue.$toast.open({
            message: "Successfully enqueued configuration",
            type: "success",
          });
        }
      } catch (tex) {
        this.commandError = "Failed to " + command + " due to an error.";
        Vue.$toast.open({ message: this.commandError, type: "error" });
      }
    },
    async sendConfiguration(command, args) {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var devicesForCommand = this.selectedDevices.map(function (d) {
        return d.split("+")[0];
      });
      var url =
        config.SENSOR_SERVICE +
        `/tenants/${this.lastSelectedTenant}/manage-devices/configure?command=${command}`;
      // var url = `https://care-ai-app-dot-sensor-api-dot-fifth-name-244415.ue.r.appspot.com/tenants/${this.lastSelectedTenant}/manage-devices/configure?command=${command}`;
      var tenants_list_request = new Request(url, {
        method: "PATCH",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        body: JSON.stringify({
          devices: devicesForCommand,
          configurations: args,
        }),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var tenantListResponse = await fetch(tenants_list_request);
        if (tenantListResponse.status === 403) {
          this.errorMessage =
            "Uh oh... You don't have the permission required to access this resource";
          Vue.$toast.open({ message: this.errorMessage, type: "error" });
          return;
        }
        if (tenantListResponse.status == 401) {
          this.errorMessage =
            "Your session has expired please login again to continue";
          Vue.$toast.open({ message: this.errorMessage, type: "error" });

          return;
        }
        if (tenantListResponse.status == 503) {
          return this.sendConfiguration(command, args);
        }
        if (tenantListResponse.status != 200) {
          this.commandError = "Failed to run " + command;
          Vue.$toast.open({ message: this.commandError, type: "error" });
        } else {
          var tenantsBody = await tenantListResponse.json();

          this.commandError = "";
          Vue.$toast.open({
            message: "Successfully enqueued configuration",
            type: "success",
          });
        }
      } catch (tex) {
        this.commandError = "Failed to " + command + " due to an error.";
        Vue.$toast.open({ message: this.commandError, type: "error" });
      }
    },
    async showFileImportScreen() {
      //var connections = await this.getConnections();
      document.getElementById("fileInput").click();
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    showSelectedDevices() {
      if (!this.selectedDevices || this.selectedDevices.length === 0) {
        return "";
      }
      var html = "";
      this.selectedDevices.forEach(function (d) {
        html += `<div style=" margin-right:5px; margin-bottom:5px; border-radius: 5px;
          padding: 0px 13px; line-height:30px; display: inline-grid; background: #ADD8E6; color: #fff;">${d.split("+")[0]
          }</div>`;
        /* html += `<div class="card" style="margin-top:5px"><span class="darkMatter" style="font-size:0.8em!important;font-weight:bolder;display:block!important;text-align:center">${
          d.split("+")[0]
        }</span><span class="smallFont" style="font-size:0.8em!important;display:block!important;text-align:center">${
          d.split("+")[1]
        }</span></div>`; */
      });
      return html;
    },
    getDeviceStatus(device) {
      var style = "padding:2px;";
      if (device.status === "ONLINE") {
        style += "background-color: green; color:#fff;";
      } else if (device.status === "OFFLINE") {
        style += "background-color: #fe490f; color:#fff;";
      } else {
        style += "background-color: #909090;";
      }

      return (
        '<span style="' +
        style +
        '">' +
        device.currentActiveConnection +
        "</span>"
      );
    },
    async exportDevices() {
      document.getElementById("exportBtn").disabled = true;
      var csv = [];
      if (this.deviceList && this.deviceList.length > 0) {
        csv.push(
          "Care.ai Sensor Id, Sensor Model, Sensor Location, Current Status, Last Known Connection, Last Health Reported (UTC), Firmware Version,Ethernet MAC Address, Ethernet IP Address, WiFi MAC Address, WiFi IP Address\n"
        );
        this.deviceList.forEach((d) => {
          var props = [];
          props.push(d.deviceId);
          props.push(d.model);
          props.push(
            '"' +
            d.location_name +
            '"'
          );
          props.push(d.status);
          props.push(d.currentActiveConnection);
          props.push(d.lastHealthReported);
          props.push(d.firmware ? d.firmware.version : "-");

          var mac = "";
          if (d.eth0) {
            props.push(d.eth0.mac);
            props.push(d.eth0.address);
            mac = "Eth:" + d.eth0.mac + "  |  ";
          } else {
            props.push("-");
            props.push("-");
          }
          if (d.wlan0) {
            props.push(d.wlan0.mac);
            props.push(d.wlan0.address);
            mac += " Wlan:" + d.wlan0.mac;
          } else {
            props.push("-");
            props.push("-");
          }

          //props.push(mac);
          var ipAddress = "";
          if (d.eth0) {
            ipAddress = "Eth: " + d.eth0.address + "  |  ";
          }
          if (d.wlan0) {
            ipAddress += "Wlan: " + d.wlan0.address;
          }
          //props.push(ipAddress);
          var rowData = props.join(",") + "\n";

          csv.push(rowData);
        });
      }
      if (csv.length === 0) {
        document.getElementById("exportBtn").disabled = false;

        //alert("Nothing to export");
        Vue.$toast.open({ message: "Nothing to export", type: "error" });
        return;
      }

      var csvFile;
      var downloadLink;

      // CSV file
      csvFile = new Blob(csv, { type: "text/csv" });

      // Download link
      downloadLink = document.createElement("a");

      // File name
      downloadLink.download = this.lastSelectedTenant + "-devices.csv";

      // Create a link to the file
      downloadLink.href = window.URL.createObjectURL(csvFile);

      // Hide download link
      downloadLink.style.display = "none";

      // Add the link to DOM
      document.body.appendChild(downloadLink);

      // Click download link
      downloadLink.click();
      document.getElementById("exportBtn").disabled = false;
    },
    async toastAlert() {
      Vue.$toast.open({ message: "You did it!", type: "success" });
    },
    async onChanged() {
      this.$bvModal.show("myModal");
    },
    async onClickProvision() {
      this.$bvModal.show("provisionModal");
    },
    async showPrinting() {
      this.$bvModal.show("myPrintingModal");
    },
    async showDeviceVideo() {
      if (this.selectedDevices && this.selectedDevices.length === 1) {
        const claims = await this.$auth.getIdTokenClaims();
        const deviceId = this.selectedDevices[0];
        var url = `${config.SENSOR_SERVICE_V2}/tenants/${this.lastSelectedTenant}/devices/${deviceId}/live-stream`;
        var device_live_video = new Request(url, {
          method: "GET",
          mode: "cors",
          withCredentials: true,
          credentials: "include",
          cache: "default",
          headers: {
            Authorization: "Bearer " + claims.__raw,
            "Content-Type": "application/json",
          },
        });
        try {
          const deviceStreamResponse = await fetch(device_live_video);
          if (deviceStreamResponse.status === 403) {
            this.errorMessage =
              "Uh oh... You don't have the permission required to access this resource";
            Vue.$toast.open({ message: this.errorMessage, type: "error" });
            return;
          }
          if (deviceStreamResponse.status == 401) {
            this.errorMessage =
              "ERR-0:Your session has expired please login again to continue";
            Vue.$toast.open({ message: this.errorMessage, type: "error" });
            return;
          }
          if (deviceStreamResponse.status == 503) {
            return this.showDeviceVideo();
          }
          if (deviceStreamResponse.status != 200) {
            this.commandError =
              "ERR-1:Failed to get the device-stream for this Device. Please check with the Administrator.";
            Vue.$toast.open({ message: this.commandError, type: "error" });
            return;
          } else {
            const deviceVideoStreemInfo = await deviceStreamResponse.json();
            this.deviceVideoStreamURL = deviceVideoStreemInfo.url;

            this.$bvModal.show("m2DeviceVideo");
          }

          this.playDeviceVideo();
        } catch (err) {
          this.commandError =
            "ERR-2:Failed to get the device-stream for this Device. Please check with the Administrator.";
          Vue.$toast.open({ message: this.commandError, type: "error" });
        }
      } else {
        Vue.$toast.open({
          message:
            "ERR-5:Device video could be display for only 1 M2 device at a time.",
          type: "error",
        });
      }
    },
    onPlayerPlay(player) {
      console.log("player play!", player);
    },
    onPlayerReady(player) {
      this.player.play();
    },
    clearSelectedDevice() {
      this.selectedDevices = [];
      this.selectedDeviceModel = "";
      this.deviceList = this.deviceListTemp;
    },
    async playDeviceVideo() {
      try {
        this.deviceVideoStreamURL = this.deviceVideoStreamURL + "#.mp4";
        // if (!this.deviceVideoStreamURL) {
        //   this.deviceVideoStreamURL = 'https://b-54c7cb80.kinesisvideo.us-east-2.amazonaws.com/hls/v1/getHLSMasterPlaylist.m3u8?SessionToken=CiDfTddB9ZWLySFcObxa5kHpP7JbtJZwFNOoXXAYqE2VyBIQkVcwTknwHCBjyRZEY2b5SRoZi8sjeNGSlKTBjCevcU6n1jiKQJH8V4gxMSIg5_o2y_SBENnXKhDhmwQuzk1SYQOUbCsN9XJ635OrE8c~';
        // }
        const videoPlayer = $("#videojs");
        if (videoPlayer) {
          videoPlayer.show();
          this.player = videojs($("#videojs")[0]);
          if (this.player) {
            this.player.src({
              withCredentials: false,
              type: "application/x-mpegURL",
              src: this.deviceVideoStreamURL,
            });
            this.player.play();
          }
        }
      } catch (err) {
        console.error("Failed to stream video from the Device.", err);
        this.commandError =
          "ERR-3:Failed to stream video from the Device. Refresh and try-again.";
        Vue.$toast.open({ message: this.commandError, type: "error" });
      }
    },
    async closePatientDeviceVideo() {
      this.deviceVideoStreamURL = "";
      if (this.player) {
        this.player.pause();
        this.player.dispose();
        this.player = null;
      }
      this.showM2DeviceVideo = false;
    },
    async showVisitorProperties() {
      this.manualCheckIn.forEach((e) => {
        e.isChecked = true;
      });

      this.$bvModal.show("visitorPropertiesModal");
      /* if(this.sendConfigurationCommand == 'set-client-settings') {
      this.$bvModal.show("myModal");
      } */
    },
    async onMappingChanged(event, mappingObj) {
      // let oldMapping = mappingObj["mapping"] ? mappingObj["mapping"] : "";
      let exitingMapping = this.manualCheckIn.filter(
        (e) => e.mapping === event.target.value
      );

      let findMapping = this.mappingList.find(
        (el) => el.value == event.target.value
      );

      if (exitingMapping && exitingMapping.length > 1) {
        mappingObj.mapping = "";
        delete mappingObj["mapping"];
        // if (oldMapping == "") {
        //
        // }
        Vue.$toast.open({
          message: findMapping.text + " is already Selected",
          type: "error",
        });
      }
    },
    async onLocationChanged() {
      //  document.getElementById('btnFetchDevices').disabled = true;
      this.locationFilter = JSON.parse(
        document.getElementById("locationFilter")
          ? document.getElementById("locationFilter").value
          : "{}"
      );

      this.nextDevicePointer = null;
      this.deviceList = [];
      this.deviceListTemp = [];
      this.devicesMessage = "";
      return this.fetchDevices();
    },
    check(data, value) {
      //debugger
      this.deviceList.forEach((e) => {
        e.selected = false;
      });
      if (value == true) {
        this.selectedDeviceModel = data.model;
        data["selected"] = value;
      } else {
        if (this.selectedDevices.length == 1) {
          this.selectedDeviceModel = "";
        }
      }
    },
    async fetchData() {
      if (!this.$auth.isAuthenticated) {
        return;
      }
      //  document.getElementById('btnFetchDevices').disabled = true;
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var tenants_list_request = new Request(
        config.TENET_SERVICE + "/tenants/?list=true",
        {
          method: "GET",
          mode: "cors",
          cache: "default",
          withCredentials: true,
          credentials: "include",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        }
      );
      try {
        var tenantListResponse = await fetch(tenants_list_request);
        if (tenantListResponse.status === 403) {
          Vue.$toast.open({
            message:
              "Uh oh... You don't have the permission required to access this resource",
            type: "error",
          });
          return;
        }
        if (tenantListResponse.status == 401) {
          Vue.$toast.open({
            message: "Your session has expired please login again to continue",
            type: "error",
          });
          return;
        }
        if (tenantListResponse.status == 503) {
          return this.fetchData();
        }
        if (tenantListResponse.status != 200) {
          Vue.$toast.open({
            message: "Unable to get data",
            type: "error",
          });
          return;
        } else {
          //console.log(tenantListResponse);
          var tenantsBody = await tenantListResponse.json();
          //console.log(tenantsBody);
          this.tenants = tenantsBody.map((t) => {
            return {
              text: t.text || t.value,
              id: t.value,
              value: t.value.toLowerCase().replace('-', ''),
            };
          });
          this.tenants = this.tenants.sort(function (a, b) {
            var nameA = a.text.toUpperCase(); // ignore upper and lowercase
            var nameB = b.text.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          });
          this.errorMessage = "";
          this.tenants.forEach((e) =>
            this.tenantsList.push({ id: e.value, name: e.text || e.value })
          );
        }
      } catch (tex) {
        this.errorMessage = "Failed to get tenant list due to an error.";
        // Vue.$toast.open("Failed to get tenant list due to an error.");
      }
      var device_request = new Request(
        config.SENSOR_SERVICE_V2 + "/statusReport",
        {
          method: "GET",
          mode: "cors",
          cache: "default",
          withCredentials: true,
          credentials: "include",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        }
      );
      try {
        var statusReportResponse = await fetch(device_request);
        if (statusReportResponse.status === 403) {
          Vue.$toast.open({
            message:
              "Uh oh... You don't have the permission required to access this resource",
            type: "error",
          });
          return;
        }
        if (statusReportResponse.status == 401) {
          Vue.$toast.open({
            message: "Your session has expired please login again to continue",
            type: "error",
          });
          return;
        }
        if (statusReportResponse.status == 503) {
          return this.fetchData();
        }
        if (statusReportResponse.status != 200) {
          Vue.$toast.open({ message: "Please refresh the page", type: "info" });
        } else {
          var deviceStatusBody = await statusReportResponse.json();
          this.deviceStats = deviceStatusBody;
          this.errorMessage = "";
          //   document.getElementById('btnFetchDevices').disabled = false;
        }
      } catch (dex) {
        Vue.$toast.open({
          message: "Failed to get device status report due to an error.",
          type: "error",
        });
      }
    },
    async fetchDevices() {
      if (!this.$auth.isAuthenticated) {
        return;
      }
      //   document.getElementById('btnFetchDevices').disabled = true;
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var tenantId = document.getElementById("tenantId").value;
      if (tenantId.length === 0) {
        this.deviceList = [];
        this.deviceListTemp = [];
        this.locationList = [];
        this.nextDevicePointer = null;
        return;
      }
      this.lastSelectedTenant = tenantId;
      var locFilter = this.locationFilter || {};
      var filter = "";
      if (locFilter.lid) {
        filter += "&location=" + locFilter.lid;
        if (locFilter.uid) {
          filter += "&unit=" + locFilter.uid;
          if (locFilter.aid) {
            filter += "&area=" + locFilter.aid;
          }
        }
      }
      //this.locationFilter = filter;
      this.commandError = "";
      var next = (this.nextDevicePointer || "limit=500&offset=0") + filter;
      var url = config.SENSOR_SERVICE + `/tenants/${tenantId}/devices/?${next}`;
      var device_request = new Request(url, {
        method: "GET",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var statusReportResponse = await fetch(device_request);
        if (statusReportResponse.status === 403) {
          this.errorMessage =
            "Uh oh... You don't have the permission required to access this resource";

          return;
        }
        if (statusReportResponse.status == 401) {
          this.errorMessage =
            "Your session has expired please login again to continue";

          return;
        }
        if (statusReportResponse.status == 503) {
          return this.fetchDevices();
        }
        if (statusReportResponse.status != 200) {
          this.errorMessage =
            "APIs are warming up. Please refresh the page in a few seconds.";
        } else {
          var deviceStatusBody = await statusReportResponse.json();
          this.deviceList =
            this.deviceList != null && this.deviceList.length > 0
              ? [...this.deviceList, ...deviceStatusBody.devices]
              : deviceStatusBody.devices;
          // this.deviceList = this.deviceList.forEach(element => {
          //   element['checked'] = false
          // });
          this.nextDevicePointer = deviceStatusBody.next;
          var page = deviceStatusBody.count;
          // console.log("hey this is it", this.deviceList)
          if (this.nextDevicePointer) {
            page = parseInt(deviceStatusBody.next.split("offset=")[1]);
            this.fetchDevices();
          }

          this.devicesMessage =
            "Listing " + page + "of " + deviceStatusBody.count;
          this.errorMessage = "";
          //     document.getElementById('btnFetchDevices').disabled = false;
        }
      } catch (dex) {
        this.errorMessage =
          "Failed to get device status report due to an error.";
        console.error("failed to get devices", dex);
      }
    },
    async fetchDevicesList(){
      let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots",
      });
      this.deviceList = [];
      this.deviceListTemp = [];
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      let deviceList=[]
      var url =
      `https://api-gateway-dot-development-cloud-services.appspot.com/search-devices/?limit=50&offset=0&deviceId={"$regex":"${this.searchPannel.enteredDeviceInfo}","$options":"i"}`
      var search_devices = new Request(url, {
        method: "GET",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var search_devices_resp = await fetch(search_devices);
        var search_devices_response = await search_devices_resp.json()
        if (search_devices_response.status == 503) {
          return this.fetchDevicesList();
        }
              this.deviceStats.total=search_devices_response.count;
              deviceList = deviceList.concat(search_devices_response.devices);
       
      } catch (error) {
        console.error(error);
      }
      this.sortDevicesList(deviceList);
      loader.hide();
    },
    
    sortDevicesList(deviceList){
      deviceList.forEach((d) => {
          const locationArea = this.areaList.find(
            (a) =>
              a.locationId === d.location &&
              a.unitId === d.unit &&
              a.areaId === d.area
          );
          if (locationArea) {
            d["location_name"] = locationArea.location_name;
            d["unit_name"] = locationArea.unit_name;
            d["area_name"] = locationArea.area_name;
            d["taxonomy_name"] = locationArea.taxonomy_name;
          }
        });
        deviceList.sort((a, b) => {
          return (
            a.location_name &&
            a.location_name.localeCompare(b.location_name) &&
            a.unit_name &&
            a.unit_name.localeCompare(b.unit_name) &&
            a.area_name &&
            a.area_name.localeCompare(b.area_name)
          );
        });
        this.deviceList = deviceList;
        this.deviceListTemp = deviceList;
        this.deviceStats.offline = this.deviceListTemp.filter(a=>a.status ==="OFFLINE" ).length;
        this.deviceStats.online = this.deviceListTemp.filter(a=>a.status ==="ONLINE" ).length;
        this.locationSearchList= this.uniqueArray(deviceList.map(item => ({text:item.location_name,value:item.location})));
        // unit list
        this.locationSearchList= this.uniqueArray(deviceList.map(item => ({text:item.location_name,value:item.location})));
         
          // area list
        this.locationSearchList= this.uniqueArray(deviceList.map(item => ({text:item.location_name,value:item.location})));
        this.facilityList = this.facilityListDeviceObj=this.locationList.map(l => {
          return {
            text: l.name,
            value: l.locationId
          }
        });
        this.locationSearchList = this.locationSearchList.sort(function (a, b) {
            var nameA = a.text; // ignore upper and lowercase
            var nameB = b.text; // ignore upper and lowercase
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          });
    },
    async fetchLocations(tenantId) {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      this.lastSelectedTenant = tenantId;
      this.nextDevicePointer = null;
      this.locationList = [];
      this.deviceList = [];
      this.deviceListTemp = [];
      this.selectedDevices = [];
      this.facilityListDeviceObj = [];
      this.areaDeviceOpsList = [];
      this.unitDeviceOpsList = [];
      var locUrl =
       config.API_GATEWAY + `/location/userLocations?tenantName=${this.lastSelectedTenant}`
      //  var locUrl = `https://tenant-service-dot-fifth-name-244415.ue.r.appspot.com/tenants/${tenantId}/locations?limit=1000`;
      var tenants_list_request = new Request(locUrl, {
        method: "GET",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var tenantListResponse = await fetch(tenants_list_request);
        if (tenantListResponse.status === 403) {
          this.errorMessage =
            "Uh oh... You don't have the permission required to access this resource";

          return;
        }
        if (tenantListResponse.status == 401) {
          this.errorMessage =
            "Your session has expired please login again to continue";

          return;
        }
        if (tenantListResponse.status == 503) {
          return this.fetchLocations(tenantId);
        }
        if (tenantListResponse.status != 200) {
          this.errorMessage =
            "APIs are warming up. Please refresh the page in a few seconds.";
        } else {
          var tenantsBody = await tenantListResponse.json();
          if (
            tenantsBody  &&
            tenantsBody.length > 0
          ) {
            tenantsBody.forEach((l) => {
              if (l.units && l.units.length > 0) {
                l.units.forEach((u) => {
                  if (u.areas && u.areas.length > 0) {
                    u.areas.forEach((a) => {
                      this.areaList.push({
                        locationId: l.locationId,
                        location_name: l.name,
                        unitId: u.id,
                        unit_name: u.name,
                        areaId: a.id,
                        area_name: a.name,
                        type: a.type,
                        taxonomy_name: l.name + " / " + u.name + " / " + a.name,
                      });
                    });
                  }
                });
                this.locationList.push({
                  locationId: l.locationId,
                  name: l.name,
                  units: l.units,
                });
              }
            });
          }
          this.errorMessage = "";
        }
      } catch (tex) {
        this.errorMessage = "Failed to get tenant list due to an error.";
        console.error("failed to get locations", tex);
      }
    },
    handleFiles(event) {
      this.importLoadingMessage = "Loading file: " + event.target.files[0];
      //alert(this.importLoadingMessage);
      //Vue.$toast.open("Loading File");
      // Check for the various File API support.
      if (window.FileReader) {
        // FileReader are supported.
        //getAsText(files[0]);
        var fileToRead = event.target.files[0];
        var reader = new FileReader();
        // Handle errors load
        reader.onerror = (evt) => {
          if (evt.target.error.name == "NotReadableError") {
            // this.importLoadingMessage = "ERROR reading file";
            Vue.$toast.open({ message: "ERROR reading file", type: "error" });
            this.importedDeviceIds = null;

            // alert("Cannot read file !");
            Vue.$toast.open({ message: "Cannot read file !", type: "error" });
          }
        };
        reader.onload = (event) => {
          this.importedDeviceIds = null;
          var csv = event.target.result;
          var allTextLines = csv.split(/\r\n|\n/);
          var lines = [];
          var headers = this.CSVtoArray(allTextLines.shift());
          this.importedLoadingMessage = "Validating Headers";
          if (!this.validateHeaders(headers)) {
            this.importedLoadingMessage =
              "Validation Failed! Missing: " + this.importedLoadingMessage;
            Vue.$toast.open({
              message: this.importedLoadingMessage,
              type: "error",
            });
            return false;
          }
          this.importedLoadingMessage = "Loading Device Id's";
          var listOfDeviceIds = [];
          while (allTextLines.length - 1) {
            listOfDeviceIds.push(
              this.csvArrayToJSON(
                headers,
                this.CSVtoArray(allTextLines.shift())
              )
            );
          }

          if (listOfDeviceIds && listOfDeviceIds.length > 100) {
            Vue.$toast.open({ message: "CSV file cannot have more than 100 deviceIds.", type: "error", });
            return falsee
          }
          this.importedDeviceIds = [];
          if (listOfDeviceIds.length > 0) {
            listOfDeviceIds.forEach((u) => {
              if (!u) {
                u = {};
              }

              if (
                u.DeviceId &&
                u.DeviceId.length > 0 &&
                this.currentSelectedConnectionId === "hclm-saml"
              ) {
                u["DeviceId"] = "hclm|" + u.deviceId;
              }
              for (var key in u) {
                if (u[key] && typeof u[key] === "string") {
                  u[key] = u[key].trim();
                }
              }
              u.isValid = this.isImportedDeviceIdValid(u);
              this.importedDeviceIds.push(u);
            });
            this.importedLoadingMessage =
              "Loaded Device Id's: " + this.importedDeviceIds.length;
          } else {
            this.importedLoadingMessage = "No users defined";
            this.importedDeviceIds = null;
          }
        };
        // Read file into memory as UTF-8
        reader.readAsText(fileToRead);
      } else {
        this.importedLoadingMessage = "Cannot read file";
        // alert("FileReader are not supported in this browser.");
        Vue.$toast.open({
          message: "FileReader are not supported in this browser",
          type: "error",
        });
      }
    },
    validateHeaders(headers) {
      if (headers && Array.isArray(headers) && headers.length >= 1) {
        var errMsg = "";
        if (!headers.includes("DeviceId")) {
          errMsg += "\r\n- DeviceId";
        }
        if (errMsg.length > 0) {
          this.importLoadingMessage = errMsg;
          return false;
        }
        return true;
      } else {
        this.importLoadingMessage =
          "Invalid File Headers! Please check the requirements";
        return false;
      }
    },
    csvArrayToJSON(headers, data) {
      if (headers && data) {
        var obj = {};
        for (var hIdx in headers) {
          var key = headers[hIdx].trim();
          if (key && key.length > 0) {
            obj[key] = data.length - 1 < hIdx ? null : data[hIdx];
          }
        }
        return obj;
      }
      return false;
    },
    CSVtoArray(text) {
      var re_valid =
        /^\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*(?:,\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*)*$/;
      //var re_value = /(?!\s*$)\s*(?:'([^'\\]*(?:\\[\S\s][^'\\]*)*)'|"([^"\\]*(?:\\[\S\s][^"\\]*)*)"|([^,'"\s\\]*(?:\s+[^,'"\s\\]+)*))\s*(?:,|$)/g;
      var re_value =
        /(?!\s*$)\s*(?:"([^"\\]*(?:\\[\S\s][^"\\]*)*)"|"([^"\\]*(?:\\[\S\s][^"\\]*)*)"|([^,"\s\\]*(?:\s+[^,"\s\\]+)*))\s*(?:,|$)/g;
      // Return NULL if input string is not well formed CSV string.
      if (!re_valid.test(text)) {
        if (!re_value.test(text)) {
          return null;
        }
      }
      var a = []; // Initialize array to receive values.
      text.replace(
        re_value, // "Walk" the string using replace with callback.
        function (m0, m1, m2, m3) {
          // Remove backslash from \' in single quoted values.
          if (m1 !== undefined) a.push(m1.replace(/\\"/g, '"').trim());
          // Remove backslash from \" in double quoted values.
          else if (m2 !== undefined) a.push(m2.replace(/\\"/g, '"').trim());
          else if (m3 !== undefined) a.push(m3.trim());
          return ""; // Return empty string.
        }
      );
      // Handle special case of empty last value.
      if (/,\s*$/.test(text)) a.push("");
      return a;
    },
    isImportedDeviceIdValid(u) {
      if (u["DeviceId"].length > 0) {
        if (!u["DeviceId"] || u["DeviceId"].length === 0) {
          u.error = "[DeviceId] is required";
          return false;
        }
        u.error = null;

        return true;
      }
    },
    //   async openMediaNode() {
    //     this.addMediaNodeObj['pexipSDKVersion']=this.pexipSDKVersionOptionArray[0];
    //     this.$bvModal.show("addModal");
    // },
    async addDeviceOperation(){
      this.deviceOperationsObj['job_type'] = this.deviceOperationsObj['job_type']?this.deviceOperationsObj['job_type'] : this.jobTypeArray[0];
      this.deviceOperationsObj['job_name'] = this.deviceOperationsObj['job_name']?this.deviceOperationsObj['job_name'] : this.jobNameArray[0];
      this.deviceOperationsObj['job_version'] = this.deviceOperationsObj['job_version']?this.deviceOperationsObj['job_version'] : this.jobVersionArray[0];

      this.deviceOperationsObj['location'] = this.deviceOperationsObj['location']?this.deviceOperationsObj['location'] : this.locationSearchList[1]['text'];

      this.deviceOperationsObj['area'] = this.deviceOperationsObj['area']?this.deviceOperationsObj['area'] : this.locationSearchList[3]['text'];

      this.deviceOperationsObj['facility'] = this.deviceOperationsObj['facility']?this.deviceOperationsObj['facility'] : this.locationSearchList[0]['text'];


          this.deviceOpsStep=1;
          this.$bvModal.show("addDeviceOperationsModal");
    },
    onDateChange(dateStr) {
      if (dateStr === 'start_date') {
        this.deviceOperationsObj.start_date =  this.startDateRange.format("YYYY-MM-DD");
      }
      if (dateStr === 'end_date') {
        this.deviceOperationsObj.end_date = this.dateRange.format("YYYY-MM-DD");
      }
    },

    saveDeviceOperations(){
      if(this.deviceOpsStep<4){
      this.deviceOpsStep=this.deviceOpsStep+1;
        // this.$bvModal.preventDefault();
      }else if(this.deviceOpsStep===4){
       //code for submission 
       this.$bvModal.hide("addDeviceOperationsModal");

      }
    },
    addMediaNode(){
      //here we need to create a API call to save the record
      this.clearModal();

    },
     // clering the value to it's previous state (ACID)
     async clearModal() {
      this.addMediaNodeObj = {};
      this.$bvModal.hide("addModal");
    },
    closeDeviceOprtaionModal(){
      this.$bvModal.hide("addDeviceOperationsModal");
      this.deviceOperationsObj={};//clearing the selection/added details after closing the model
    },
  },
};
</script>
<style lang="scss">
body .dropdown .dropdown-input {
  border: none !important;
  padding: 0 15px !important;
  background: none !important;
  font-size: 16px !important;
}

body .dropdown.tenantsList .dropdown-input {
  color: #fff !important;
  border: none !important;
  padding: 0 15px !important;
  background: none !important;
  font-size: 16px !important;
}

body .dropdown .dropdown-input:focus,
body .dropdown .dropdown-input:focus-visible {
  outline: none;
}

#visitorPropertiesModal .btn-primary {
  background-color: #50b9d4;
  border: 1px solid #50b9d4;
  outline: none;
}

.tenantsList input::-webkit-input-placeholder {
  color: #fff !important;
}

#visitorPropertiesModal .btn-primary:hover {
  color: #fff;
  background-color: #1a80a8;
  border-color: #1a80a8;
}

#visitorPropertiesModal .btn-primary:focus {
  box-shadow: none;
}

#visitorPropertiesModal .modal-title {
  color: #fff;
}

#visitorPropertiesModal .btn-secondary {
  background-color: #f27778;
  border: 1px solid #f27778;
  outline: none;
}

#visitorPropertiesModal .btn-secondary:hover {
  color: #fff;
  background-color: #f34243;
  border-color: #f34243;
}

#visitorPropertiesModal .btn-secondary:focus {
  box-shadow: none;
}

#visitorPropertiesModal .modal-header .close {
  outline: none;
}

#visitorPropertiesModal .close:not(:disabled):not(.disabled):focus,
#visitorPropertiesModal .close:not(:disabled):not(.disabled):hover {
  opacity: 1;
}

#visitorPropertiesModal .modal-content {
  border: 1px solid #ebebeb;
}

#visitorPropertiesModal .modal-footer {
  border-top: none;
}

#visitorPropertiesModal .modal-xl,
#visitorPropertiesModal .container {
  max-width: 1240px;
}

#myPrintingModal___BV_modal_title_ {
  color: white;
  font-weight: 200;
}

#myPrintingModal___BV_modal_footer_ .btn {
  background-color: #1dd8f6;
  border: none;
  border-radius: 5px;
}

#provisionModal .modal-header,
#provisionModal .modal-footer {
  display: none !important;
}
#provisionModal .modal-dialog{
  max-width:420px;
}

.requestCol {
  border-radius: 1rem;
  // min-height: 50vh;
  border:none;
}

.requestCol a{
  color:#484848;
}

// .provisionCol {
//   border-radius: 5px;
//   border: 1px solid gray;
// }

body select#printingPort {
  width: 100% !important;
}

#myModal___BV_modal_body_,
#myPrintingModal___BV_modal_body_ {
  max-height: 500px;
  overflow: auto;
}

::-webkit-scrollbar {
  width: 5px;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: #d7d7d7 !important;
  border-radius: 10px;
}

::-webkit-scrollbar-track {
  background: #fafafa !important;
}
.clear-device .clear-icon{
color:#fff;
font-size:12px;
position:relative;
top:2px;
cursor: pointer;
}
#addModal .modal-dialog{
  max-width:420px;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 46%;
    margin: 5.35rem auto;
  }
}
</style>

<style lang="scss" scoped>
.text-truncate-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
 .row2 {
  border: 1px solid #ebebeb;
  padding: 10px;
  margin-left: 10px;
  margin-right: 10px;
}
.global-search-container{
  display: inline-flex;
  text-align: end;
  width:100%;
}
.device-search-input{
  border: 1px solid #ebebeb !important;
  margin-right: 15px;
  padding-left: 10px ;
  border-radius: 5px;
  width:30%
}
@font-face {
  font-family: GTWalsheimPro-Regular;
  src: url(../assets/fonts/GTWalsheimPro-Regular.eot);
  src: url(../assets/fonts/GTWalsheimPro-Regular.eot) format("embedded-opentype"),
    url(../assets/fonts/GTWalsheimPro-Regular.ttf) format("truetype"),
    url(../assets/fonts/GTWalsheimPro-Regular.svg) format("svg");
  font-weight: normal;
  font-style: normal;
}

*,
:after,
:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

body,
html {
  font-family: GTWalsheimPro-Regular !important;
  background: #fff !important;
  font-size: 16px;
  overflow-x: hidden;
}

b,
strong {
  font-weight: 500;
}
#addModal___BV_modal_outer_ input[type="text"]{
  border: 1px solid #ced4da;
  padding:0 10px;
  height: 36px;
}
button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled],
html input[disabled] {
  cursor: default;
}

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
  outline: 0 !important;
}

a,
a img,
a:active,
a:focus,
button:focus,
a:hover {
  outline: 0 !important;
  -webkit-transition: all 0.35s;
  -moz-transition: all 0.35s;
  transition: all 0.35s;
  text-decoration: none;
  cursor: pointer;
  color: #5ed1d1;
}

a:hover {
  text-decoration: underline;
}

img {
  border: 0 !important;
}

a:focus:not(:hover),
button:focus:not(:hover) {
  outline: 0;
}

::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color:#6a6a6a !important; 
}

::-moz-placeholder {
  /* Firefox 19+ */
  color: rgba(4, 78, 89, 1) !important;
}

:-ms-input-placeholder {
  /* IE 10+ */
  color: rgba(4, 78, 89, 1) !important;
}

:-moz-placeholder {
  /* Firefox 18- */
  color: rgba(4, 78, 89, 1) !important;
}

.requiredItem::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #dc858b !important;
}

.requiredItem::-moz-placeholder {
  /* Firefox 19+ */
  color: #dc858b !important;
}

.requiredItem:-ms-input-placeholder {
  /* IE 10+ */
  color: #dc858b !important;
}


.ui.selection.dropdown {
  border: none !important;
  box-shadow: none !important;
  i.dropdown.icon {
    display: none;
  }
}


.requiredItem:-moz-placeholder {
  /* Firefox 18- */
  color: #dc858b !important;
}

input[type="text"],
input[type="email"],
input[type="search"],
input[type="number"],
input[type="password"],
input[type="tel"],
input[type="date"],
select.form-control,
textarea.form-control {
  box-shadow: none;
  background: transparent;
  outline: none !important;
  border: none;
  border-radius: 5px;
  width: 100%;
  padding: 7px 0px;
  color: #6a6a6a;
}

input[type="text"]:focus,
input[type="email"]:focus,
input[type="search"]:focus,
input[type="number"]:focus,
input[type="password"]:focus,
input[type="tel"]:focus,
input[type="date"]:focus,
select.form-control:focus,
textarea.form-control:focus {
  box-shadow: none;
  background: transparent;
  outline: none !important;
}

input[type="text"].requiredItem:focus,
input[type="email"].requiredItem:focus,
input[type="search"].requiredItem:focus,
input[type="number"].requiredItem:focus,
input[type="password"].requiredItem:focus,
input[type="tel"].requiredItem:focus,
input[type="date"].requiredItem:focus,
select.form-control.requiredItem:focus,
textarea.form-control.requiredItem:focus,
textarea.requiredItem:focus {
  box-shadow: none;
  background: transparent;
  outline: none !important;
  border-bottom: 1px solid #dc858b;
}

input[type="text"]:hover,
input[type="email"]:hover,
input[type="search"]:hover,
input[type="number"]:hover,
input[type="password"]:hover,
input[type="tel"]:hover,
input[type="date"]:hover,
textarea.form-control:hover {
  box-shadow: none;
  /* background: #fff;*/
  outline: none !important;
}

input[type="text"].requiredItem:hover,
input[type="email"].requiredItem:hover,
input[type="search"].requiredItem:hover,
input[type="number"].requiredItem:hover,
input[type="password"].requiredItem:hover,
input[type="tel"].requiredItem:hover,
input[type="date"].requiredItem:hover,
select.form-control.requiredItem:hover,
textarea.form-control.requiredItem:hover {
  box-shadow: none;
  background: transparent;
  outline: none !important;
}

input[type="text"]:hover::-webkit-input-placeholder,
input[type="email"]:hover::-webkit-input-placeholder,
input[type="search"]:hover::-webkit-input-placeholder,
input[type="number"]:hover::-webkit-input-placeholder,
input[type="password"]:hover::-webkit-input-placeholder,
input[type="tel"]:hover::-webkit-input-placeholder,
input[type="date"]:hover::-webkit-input-placeholder,
select.form-control:hover::-webkit-input-placeholder,
textarea.form-control:hover::-webkit-input-placeholder,
textarea:hover::-webkit-input-placeholder,
input[type="text"]:focus::-webkit-input-placeholder,
input[type="email"]:focus::-webkit-input-placeholder,
input[type="search"]:focus::-webkit-input-placeholder,
input[type="number"]:focus::-webkit-input-placeholder,
input[type="password"]:focus::-webkit-input-placeholder,
input[type="tel"]:focus::-webkit-input-placeholder,
input[type="date"]:focus::-webkit-input-placeholder,
select.form-control:focus::-webkit-input-placeholder,
textarea.form-control:focus::-webkit-input-placeholder,
textarea:focus::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #6a6a6a !important;
}

input[type="text"].requiredItem:hover::-webkit-input-placeholder,
input[type="email"].requiredItem:hover::-webkit-input-placeholder,
input[type="search"].requiredItem:hover::-webkit-input-placeholder,
input[type="number"].requiredItem:hover::-webkit-input-placeholder,
input[type="password"].requiredItem:hover::-webkit-input-placeholder,
input[type="tel"].requiredItem:hover::-webkit-input-placeholder,
input[type="date"].requiredItem:hover::-webkit-input-placeholder,
select.form-control.requiredItem:hover::-webkit-input-placeholder,
textarea.form-control.requiredItem:hover::-webkit-input-placeholder,
textarea.requiredItem:hover::-webkit-input-placeholder,
input[type="text"].requiredItem:focus::-webkit-input-placeholder,
input[type="email"].requiredItem:focus::-webkit-input-placeholder,
input[type="search"].requiredItem:focus::-webkit-input-placeholder,
input[type="number"].requiredItem:focus::-webkit-input-placeholder,
input[type="password"].requiredItem:focus::-webkit-input-placeholder,
input[type="tel"].requiredItem:focus::-webkit-input-placeholder,
input[type="date"].requiredItem:focus::-webkit-input-placeholder,
select.form-control.requiredItem:focus::-webkit-input-placeholder,
textarea.form-control.requiredItem:focus::-webkit-input-placeholder,
textarea.requiredItem:focus::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #dc858b !important;
}

input[type="text"]:hover::-moz-placeholder,
input[type="email"]:hover::-moz-placeholder,
input[type="search"]:hover::-moz-placeholder,
input[type="number"]:hover::-moz-placeholder,
input[type="password"]:hover::-moz-placeholder,
input[type="tel"]:hover::-moz-placeholder,
input[type="date"]:hover::-moz-placeholder,
select.form-control:hover::-moz-placeholder,
textarea:hover::-moz-placeholder,
textarea.form-control:hover::-moz-placeholder,
input[type="text"]:focus::-moz-placeholder,
input[type="email"]:focus::-moz-placeholder,
input[type="search"]:focus::-moz-placeholder,
input[type="number"]:focus::-moz-placeholder,
input[type="password"]:focus::-moz-placeholder,
input[type="tel"]:focus::-moz-placeholder,
input[type="date"]:focus::-moz-placeholder,
select.form-control:focus::-moz-placeholder,
textarea.form-control:focus::-moz-placeholder,
textarea:focus::-moz-placeholder {
  /* Firefox 19+ */
  color: #fff !important;
}

input[type="text"].requiredItem:hover::-moz-placeholder,
input[type="email"].requiredItem:hover::-moz-placeholder,
input[type="search"].requiredItem:hover::-moz-placeholder,
input[type="number"].requiredItem:hover::-moz-placeholder,
input[type="password"].requiredItem:hover::-moz-placeholder,
input[type="tel"].requiredItem:hover::-moz-placeholder,
input[type="date"].requiredItem:hover::-moz-placeholder,
select.form-control.requiredItem:hover::-moz-placeholder,
textarea.form-control.requiredItem:hover::-moz-placeholder,
input[type="text"].requiredItem:focus::-moz-placeholder,
input[type="email"].requiredItem:focus::-moz-placeholder,
input[type="search"].requiredItem:focus::-moz-placeholder,
input[type="number"].requiredItem:focus::-moz-placeholder,
input[type="password"].requiredItem:focus::-moz-placeholder,
input[type="tel"].requiredItem:focus::-moz-placeholder,
input[type="date"].requiredItem:focus::-moz-placeholder,
select.form-control.requiredItem:focus::-moz-placeholder,
textarea.form-control.requiredItem:focus::-moz-placeholder {
  /* Firefox 19+ */
  color: #dc858b !important;
}

input[type="text"]:hover:-ms-input-placeholder,
input[type="email"]:hover:-ms-input-placeholder,
input[type="search"]:hover:-ms-input-placeholder,
input[type="number"]:hover:-ms-input-placeholder,
input[type="password"]:hover:-ms-input-placeholder,
input[type="tel"]:hover:-ms-input-placeholder,
input[type="date"]:hover:-ms-input-placeholder,
select.form-control:hover:-ms-input-placeholder,
textarea.form-control:hover:-ms-input-placeholder,
input[type="text"]:focus:-ms-input-placeholder,
input[type="email"]:focus:-ms-input-placeholder,
input[type="search"]:focus:-ms-input-placeholder,
input[type="number"]:focus:-ms-input-placeholder,
input[type="password"]:focus:-ms-input-placeholder,
input[type="tel"]:focus:-ms-input-placeholder,
input[type="date"]:focus:-ms-input-placeholder,
select.form-control:focus:-ms-input-placeholder,
textarea.form-control:focus:-ms-input-placeholder {
  /* IE 10+ */
  color: #fff !important;
}

input[type="text"].requiredItem:hover:-ms-input-placeholder,
input[type="email"].requiredItem:hover:-ms-input-placeholder,
input[type="search"].requiredItem:hover:-ms-input-placeholder,
input[type="number"].requiredItem:hover:-ms-input-placeholder,
input[type="password"].requiredItem:hover:-ms-input-placeholder,
input[type="tel"].requiredItem:hover:-ms-input-placeholder,
input[type="date"].requiredItem:hover:-ms-input-placeholder,
select.form-control.requiredItem:hover:-ms-input-placeholder,
textarea.form-control.requiredItem:hover:-ms-input-placeholder,
input[type="text"].requiredItem:focus:-ms-input-placeholder,
input[type="email"].requiredItem:focus:-ms-input-placeholder,
input[type="search"].requiredItem:focus:-ms-input-placeholder,
input[type="number"].requiredItem:focus:-ms-input-placeholder,
input[type="password"].requiredItem:focus:-ms-input-placeholder,
input[type="tel"].requiredItem:focus:-ms-input-placeholder,
input[type="date"].requiredItem:focus:-ms-input-placeholder,
select.form-control.requiredItem:focus:-ms-input-placeholder,
textarea.form-control.requiredItem:focus:-ms-input-placeholder {
  /* IE 10+ */
  color: #dc858b !important;
}

input[type="text"]:hover:-moz-placeholder,
input[type="email"]:hover:-moz-placeholder,
input[type="search"]:hover:-moz-placeholder,
input[type="number"]:hover:-moz-placeholder,
input[type="password"]:hover:-moz-placeholder,
input[type="tel"]:hover:-moz-placeholder,
input[type="date"]:hover:-moz-placeholder,
select.form-control:hover:-moz-placeholder,
textarea.form-control:hover:-moz-placeholder,
input[type="text"]:focus:-moz-placeholder,
input[type="email"]:focus:-moz-placeholder,
input[type="search"]:focus:-moz-placeholder,
input[type="number"]:focus:-moz-placeholder,
input[type="password"]:focus:-moz-placeholder,
input[type="tel"]:focus:-moz-placeholder,
input[type="date"]:focus:-moz-placeholder,
select.form-control:focus:-moz-placeholder,
textarea.form-control:focus:-moz-placeholder {
  /* Firefox 18- */
  color: #fff !important;
}

input[type="text"].requiredItem:hover:-moz-placeholder,
input[type="email"].requiredItem:hover:-moz-placeholder,
input[type="search"].requiredItem:hover:-moz-placeholder,
input[type="number"].requiredItem:hover:-moz-placeholder,
input[type="password"].requiredItem:hover:-moz-placeholder,
input[type="tel"].requiredItem:hover:-moz-placeholder,
input[type="date"].requiredItem:hover:-moz-placeholder,
select.form-control.requiredItem:hover:-moz-placeholder,
textarea.form-control.requiredItem:hover:-moz-placeholder,
input[type="text"].requiredItem:focus:-moz-placeholder,
input[type="email"].requiredItem:focus:-moz-placeholder,
input[type="search"].requiredItem:focus:-moz-placeholder,
input[type="number"].requiredItem:focus:-moz-placeholder,
input[type="password"].requiredItem:focus:-moz-placeholder,
input[type="tel"].requiredItem:focus:-moz-placeholder,
input[type="date"].requiredItem:focus:-moz-placeholder,
select.form-control.requiredItem:focus:-moz-placeholder,
textarea.form-control.requiredItem:focus:-moz-placeholder {
  /* Firefox 18- */
  color: #dc858b !important;
}

::-moz-selection {
  /* Code for Firefox */
  color: #fbeeef;
  background: #202533;
}

::selection {
  color: #fbeeef;
  background: #202533;
}

/* Scroll Bar Styling */

/* width */
::-webkit-scrollbar {
  width: 5px;
  border-radius: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f2fdff;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #a6e3f0;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #a6e3f0;
  border-radius: 10px;
}

/* Checkbox CSS Starts here */
.checkbox-container {
  display: block;
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-bottom: 0;
  color:#6a6a6a;
}

/* Hide the browser's default checkbox */
.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 4px;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: #ffffff;
  border: 1px solid #e7e7e7;
  border-radius: 3px;
}

.checkmark-disabled {
  position: absolute;
  top: 4px;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: #e7e7e7;
  border: 1px solid #e7e7e7;
  border-radius: 3px;
}

html input[disabled]~.checkmark,
html input[disabled]~.checkmark:hover {
  border: 1px solid #f27778;
  cursor: not-allowed;
}

/* On mouse-over, add a grey background color */
.checkbox-container:hover input~.checkmark {
  border: 1px solid #1dd8f6;
}

/* When the checkbox is checked, add a blue background */
.checkbox-container input:checked~.checkmark {
  background-color: #1dd8f6;
  border: 1px solid #1dd8f6;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox-container input:checked~.checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox-container .checkmark:after {
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

/* Checkbox CSS ends here */
.bodyArea {
  font-family: GTWalsheimPro-Regular;
}

/* Header CSS */
.headerWrapper {
  height: 80px;
  border-bottom: 1px solid #e5f0f2;
  width: 100%;
  padding: 0 15px;
}

a.userMenuDropDown {
  background: transparent;
  border: 0px solid;
  color: #6a6a6a;
  padding: 0;
  text-decoration: none;
}

.userMenuDropDown img {
  padding-right: 15px;
}

a.userMenuDropDown::after {
  position: relative;
  top: 2px;
  margin-left: 15px;
}

a.userMenuDropDown:hover {
  color: #1dd8f6;
}

.userMenuDropDownData {
  top: 30px !important;
  padding: 0 !important;
  border-radius: 0;
  border-top: 0px solid;
}

.userMenuDropDownData a {
  padding: 0 15px;
  line-height: 40px;
}

.userMenuDropDownData a:hover {
  color: #1dd8f6;
  background: #f2fdff;
}

.menuItemsWrapper {
  border-right: 1px solid #e5f0f2;
  padding-right: 5px !important;
  margin-right: 5px !important;
}

.menuItem {
  align-items: center;
  display: inline-flex;
  padding-left: 40px;
  position: relative;
  color: #6a6a6a;
}

.menuItem>a {
  color: #6a6a6a;
  text-decoration: none;
}

.menuItem:hover,
.menuItem.active {
  color: #1dd8f6;
  cursor: pointer;
}

.menuItem:hover>a,
.menuItem.active>a {
  color: #1dd8f6;
  cursor: pointer;
  text-decoration: none;
}

.menuItem img {
  padding-right: 10px;
  width: 30px;
}

.menuItem:after,
.menuItem:after {
  content: "";
  background: #f27778;
  height: 3px;
  width: 0;
  position: absolute;
  top: 49px;
  transition: 0.5s;
  opacity: 0;
}

.menuItem:hover:after,
.menuItem.active:after {
  width: calc(100% - 40px);
  opacity: 1;
}

.statistics {
  display: inline-flex;
  padding-left: 20px;
  margin-left: 20px;
  border-left: 1px solid #e5f0f2;
  color: #1dd8f6;
  font-size: 22px;
  align-items: flex-end;
  line-height: 25px;
}

.statistics>span {
  color: #6a6a6a;
  font-size: 19px;
  line-height: 1;
}

.dashboardBlocksWrapper {
  padding: 30px 15px;
  background: #f2fdff;
  border-bottom: 1px solid #e5f0f2;
}

.dashboardBlock {
  background: red;
  margin: 0 15px;
  padding: 30px;
  border-radius: 10px;
}

.dashboardIcon {
  float: left;
  margin-right: 20px;
}

.dashboardNumber {
  float: left;
  font-size: 45px;
  color: #fff;
  line-height: 1;
}

.dashboardNumber>span {
  font-size: 16px;
  display: block;
}

.dashboardBlock:first-child {
  background: rgb(0, 192, 255);
  background: linear-gradient(45deg,
      rgba(0, 192, 255, 1) 0%,
      rgba(0, 192, 255, 1) 35%,
      rgba(26, 102, 168, 1) 100%);
}

.dashboardBlock:nth-child(2) {
  background: rgb(0, 255, 169);
  background: linear-gradient(45deg,
      rgba(0, 255, 169, 1) 0%,
      rgba(13, 77, 255, 1) 100%);
}

.dashboardBlock:nth-child(3) {
  background: rgb(31, 201, 253);
  background: linear-gradient(45deg,
      rgba(31, 201, 253, 1) 0%,
      rgba(252, 0, 97, 1) 100%);
}

.dashboardBlock:nth-child(4) {
  background: rgb(163, 44, 223);
  background: linear-gradient(45deg,
      rgba(163, 44, 223, 1) 0%,
      rgba(138, 54, 220, 1) 33%,
      rgba(77, 79, 215, 1) 66%,
      rgba(16, 106, 210, 1) 100%);
}

.dashboardBlock:nth-child(5) {
  background: rgb(0, 255, 255);
  background: linear-gradient(45deg,
      rgba(0, 255, 255, 1) 0%,
      rgba(147, 39, 143, 1) 100%);
}

.dashboardBlock:nth-child(6) {
  background: rgb(163, 44, 223);
  background: linear-gradient(45deg,
      rgba(163, 44, 223, 1) 0%,
      rgba(138, 54, 220, 1) 33%,
      rgba(77, 79, 215, 1) 66%,
      rgba(16, 106, 210, 1) 100%);
}

.dashboardBlock:last-child {
  background: rgb(254, 193, 148);
  background: linear-gradient(45deg,
      rgba(254, 193, 148, 1) 0%,
      rgba(254, 168, 141, 1) 30%,
      rgba(254, 107, 125, 1) 50%,
      rgba(254, 8, 99, 1) 70%,
      rgba(255, 0, 97, 1) 100%);
}

.facilityInfoWrapper {
  overflow: auto;
  max-height: calc(100vh - 262px);
}

.facilityInfoRow {
  padding: 30px 15px 0 15px;
  background: #fff;
  width: 100%;
}

.facilityInfo {
  color: #6a6a6a;
  font-size: 14px;
  margin: 0 15px 30px 15px;
  border: 1px solid #e5f0f2;
  border-radius: 10px;
  padding: 0;
  max-width: calc((100vw / 7) - 35px);
  width: calc((100vw / 7) - 35px);
}

.facilityInfo .dashboardNumber {
  color: #1a80a8;
  padding: 0 25px;
  font-size: 55px;
}

.facilityName {
  background: #f2fdff;
  color: #1dd8f6;
  font-size: 16px;
  text-align: center;
  padding: 10px 5px;
  border-radius: 0 0 10px 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
}

.infoWrapper {
  padding: 10px 20px;
  border-left: 1px solid #e5f0f2;
}
.compactFilterWrapper .dropdown:before {
  content: "";
  border: solid #8e8e8e;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  position: absolute;
  right: 15px;
  top: 13px;
}

.infoItem {
  display: flex;
  line-height: 20px;
}

.pageHeader {
  height: 56px;
  color: #fff;
  background: #484848;
  font-size: 15px;
  padding: 0 15px;
}

.filterWrapper {
  background: #575757;
  display: inline-flex;
  padding: 0px 10px;
  font-size: 15px;

  min-width: 345px;
  max-width: 345px;
  border-radius: 5px;
  margin-left: 0px;
  margin-right:10px;
  //max-width: 250px;
  line-height: 36px;
  text-overflow: ellipsis;
}

.filterHeader .filterWrapper {
  border: 1px solid #ebebeb;
  background: #fff;
}

 .filterText {
   color: #6a6a6a;
   opacity: 1;
   padding-right: 5px;
   white-space:nowrap;
 }

.filterWrapper .dropdown {
  /*  width: 100%;
  text-align: left;
    color: #fff;
    border: none; */
  cursor: pointer;
  background: transparent !important;
  position: relative;
}

.filterWrapper .dropdown:before {
  content: "";
  border: solid #8e8e8e;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  position: absolute;
  right: 0px;
  top: 15px;
}
.provisionCol .filterWrapper.exportBtn{
  background:#1dd8f6;
}
.provisionCol .filterWrapper.exportBtn:hover{
  background:#3288D2;
}

.filterWrapper.exportBtn {
  max-width: none !important;
  min-width: 0 !important;
  border: none;
  color: #fff;
}
.filterWrapper.normalBtn{
  max-width: none !important;
  min-width: 0 !important;
  border: none;
  color: #fff;
  background:#1dd8f6;
}
.filterWrapper.normalBtn:hover{
  background:#3188d2;
}
.filterWrapper#ProvisionBtn{
  margin-right:0px;
}

.filterWrapper select {
  width: 100%;
  text-align: left;
  border: none;
}

.filterWrapper select.active {
  color: #6a6a6a;
}

.filterDropDown {
  color: #fff;
  opacity: 1;
  text-decoration: none;
  width: 100%;
  display: inline-block;
}

.filterDropDown:after {
  float: right;
  position: relative;
  top: 10px;
}

.filterDropDown:hover {
  text-decoration: none;
}

.filterDropDownData,
.actionDropDownData {
  padding: 0;
  border-radius: 0;
  top: 21px !important;
  border: 1px solid #e5f0f2;
}

::v-deep  .ui.search.selection.dropdown>input.search{
  padding:.67857143em 2.1em .67857143em 5px;
}
::v-deep  .provisionCol .ui.search.selection.dropdown>input.search{
  border:1px solid #ebebeb !important;
  border-radius:5px;
}
::v-deep  .ui.search.dropdown>.text{
  color:#6a6a6a;
  left:-1px;
}
::v-deep  .provisionCol input.text{
  border:1px solid #ebebeb !important;
  border-radius:5px;
  padding:.0 10px;
  height:38px;
}

::v-deep .ui.selection.active.dropdown .menu {
  border: 1px solid #EBEBEB;
  box-shadow: 0 2px 3px 0 rgba(34, 36, 38, .15);
  padding: 10px 0;
  margin-top: 1px;
  border-top-width: 1px !important;
}

.actionDropDownData {
  top: 10px !important;
  min-width: 450px !important;
  background: #fff !important;
  border-radius: 5px !important;
  max-width: 300px !important;
  border: 0px solid #e5f0f2;
  -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
  left: -150px;
}

.actionWrapper {
  padding: 10px 0;
}

.actionWrapperRow {
  padding-bottom: 5px;
  margin-bottom: 5px !important;
  border-bottom: 1px solid #dceaea;
}

.actionWrapperRow:last-child {
  padding-bottom: 0;
  margin-bottom: 0 !important;
  border-bottom: 0px solid;
}

.actionWrapperRow .actionWrapperRowHeading {
  color: #808f96;
  font-size: 15px;
  font-family: GTWalsheimPro-Regular;
  letter-spacing: 0px;
  opacity: 1;
}

.actionBtn {
  display: inline-flex;
  font-size: 12px;
  font-family: GTWalsheimPro-Regular;
  letter-spacing: 0px;
  color: #6a6a6a;
  border: 1px solid #dceaea;
  padding: 0px 10px;
  height: 30px;
  line-height: 30px;
  min-width: 50px;
  cursor: pointer;
  justify-content:center;
}

.actionBtn.installBtn {
  border-radius: 5px 0 0 5px;
}
.actionBtn.installBtn.one {
  border-radius: 5px;
}

.actionBtn.uninstallBtn {
  border-radius: 0 5px 5px 0;
}
.actionBtn.uninstallBtn:hover{
  background:#f27778;
  color:#fff;
  border:1px solid #f27778;
}

.actionInput.actionBtn.installBtn {
  max-width: 50px;
  display: inline-flex;
  cursor: auto;
}

.actionInput1.actionBtn.installBtn {
  max-width: 105px;
  display: inline-flex;
  cursor: auto;
  top: -1px;
  position: relative;
}

.actionBtn.settingBtn {
  border-radius: 30px 30px 30px 30px;
}

.actionBtn.clientShowBtn {
  border-radius: 5px;
  min-width: 100px;
  text-align: center !important;
  padding: 0;
  display: inline-grid;
  background:#1dd8f6;
  color: #fff;
}

.actionBtn.clientShowBtn:hover {
  background: #3188D2;
}

.actionBtn.deviceShowBtn {
  border-radius: 30px;
  min-width: 80px;
  text-align: center !important;
  padding: 0;
  display: inline-grid;
  background: #00b5da;
  color: #fff;
}

.actionBtn.active {
  background: #50b9d4;
  color: #fff;
  border: 1px solid #50b9d4;
}

.actionBtn.showBtn {
  background: #1dd8f6;
  color: #fff;
  border: 1px solid #1dd8f6;
  text-align:center;
}
.actionBtn.showBtn:hover{
  background:#3188D2;
  border: 1px solid #3188D2;
}

.actionBtn.hideBtn {
  background: #daf9ff;
  color: #50b9d4;
  border: 1px solid #daf9ff;
}

.filterDropDownData>a,
.actionDropDownData>a {
  color: #6a6a6a;
  text-decoration: none;
  padding: 5px 15px;
  position: relative;
}

.filterDropDownData>a:hover,
.filterDropDownData>a.active,
.actionDropDownData>a:hover,
.actionDropDownData>a.active {
  text-decoration: none;
  background: #f2fdff;
  color: #1dd8f6;
}

.filterDropDownData>a::after,
.actionDropDownData>a::after {
  content: "";
  height: 1px;
  width: 70%;
  left: 15%;
  position: absolute;
  bottom: 0;
  background: #daf9ff;
}

.filterDropDownData>a:last-child::after,
.filterDropDownData>a.active::after,
.filterDropDownData>a:hover:after,
.actionDropDownData>a:last-child::after,
.actionDropDownData>a.active::after,
.actionDropDownData>a:hover:after {
  display: none;
}

.pageDataWrapper {
  padding: 20px;
}

.contentHeader {
    overflow: unset;
    background: #EBEBEB;
    height: 42px;
    color: #484848;
    border-radius: 5px;
    padding-right:10px;
}
.contentHeader .dropdown{
  height:24px;
  line-height:24px;
}
.contentHeader .dropdown:before{
  border: solid #484848;
  right: 0;
  top: 9px;
  border-width: 0 2px 2px 0;
  display:none;
}
.contentHeader .checkbox-container{
  padding-left:0px;
  color: #484848;
}


.contentHeader>div {
  border-left: 1px solid #c7c7c7;
  display: inline-flex;
  align-items: center;
}

.contentHeader>div:first-child {
  border-left: 0px solid;
}

.contentDataWrapper {
  overflow: auto;
  max-height: calc(85vh - 180px);
  padding-right: 5px;
}

.contentData {
  background: #f8fafa;
  color: #6a6a6a;
  height: 60px;
  margin-top: 10px !important;
  cursor: pointer;
}

.contentData:hover,
.contentData.active {
  background: #f2fdff;
}

.contentData>div {
  border-left: 1px solid #e7e7e7;
  align-items: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
}

.contentData>div:first-child {
  border-left: 0px solid;
}

.devicesPageHeader {
  padding-left: 0;
  padding-right: 0px;
}

.deviceStatus {
  height: 56px;
  line-height: 56px;
  padding: 0 15px;
  background: #66be6d;
}

.deviceStatus.offlineDevices {
  background: #f27778;
}

.deviceStatus.totalDevices {
  background: #3188D2;
}

.devicesPageHeader .filterWrapper {
  height:36px;
  // max-width: 200px;
  min-width: 42%;
}
.devicesPageHeader .filterWrapper:hover{
  background:#1dd8f6;
  cursor:pointer;
}

.actionDropDown {
  background: #1dd8f6;
  border-radius: 5px;
  color: #fff !important;
  float: right;
  text-align: left;

  width: auto;
  padding: 0 20px 0 10px !important;
  height: 24px !important;
  line-height: 24px;
}

.actionDropDown:after {
  right: 7px;
  position: absolute;
  top: 12px;
}

.actionDropDown:hover {
  text-decoration: none;
}

.contentData>div .actionDropDown {
  background: transparent;
  border: 1px solid #dedede;
  color: #6a6a6a;
  box-shadow: none !important;
  outline: none !important;
  width: auto;
  padding: 5px 15px;
}

.deviceName {
  border-bottom: 1px solid #e7e7e7;
  padding-bottom: 5px !important;
  margin-bottom: 5px;
}

.deviceName>span {
  color: #3188D2;
  padding-right: 5px;
}

.deviceName.noBorder {
  border-bottom: 0px solid #e7e7e7;
  padding-bottom: 0px !important;
  margin-bottom: 0px;
}

.deviceDataWrapper .contentData {
  height: 80px;
  border:1px solid #ebebeb;
  color:#484848;
  border-radius:5px;
}

.deviceDataWrapper .contentData>div:last-child {
  display: flex;
  overflow: unset;
  padding-top: 6px !important;
}

.importBtn {
  background: #1dd8f6;
  display: inline-flex;
  padding: 5px 15px;
  font-size: 16px;
  border-radius: 5px;
  margin-left: 15px;
  width: auto;
  color: #fff;
  border: 1px solid #1dd8f6;
  box-shadow: none !important;
  outline: none !important;
}

.provisionDropdown {
  box-shadow: none;
  background: transparent;
  outline: none !important;
  border: 1px solid #dceaea;
  border-radius: 5px;
  height: 40px;
  margin-top: 10px;
  color: #6a6a6a;
  cursor: pointer;
}

.importBtn:hover {
  color: #1dd8f6;
  cursor: pointer;
  background: #fff;
}

.hasNotifications {
  max-width: 160px;
}

.selectArea {
  max-width: 125px;
}

.userContentWrapper .contentData>div:first-child,
.userContentWrapper .contentData>div:nth-child(2) {
  display: flex;
}

.userContentWrapper .contentData>div span {
  color: #6a6a6a;
  padding-right: 5px;
}

.userDetailContentHeader {
  background: #f2fdff;
  color: #1a80a8;
  font-size: 16px;
  height: 60px;
}

.userDetailContentHeader>div {
  display: inline-flex;
}

.buttonItem {
  border: 1px solid #1dd8f6;
  border-radius: 5px;
  padding: 5px 20px;
  margin-left: 0px;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  background: #1dd8f6;
}

.buttonItem:hover {
  background: #3188D2;
  color: #fff;
  border:1px solid #3288D2;
}

.buttonItem img {
  margin-left: 15px;
}

.detailWrapper {
  padding: 20px;
  border-radius: 5px;
  border: 1px solid #a6e3f0;
  margin-top: 20px !important;
  max-height: calc(100vh - 300px);
}

.userDemograpics {
  width: 100%;
  padding-bottom: 20px !important;
  margin-bottom: 20px !important;
  border-bottom: 1px solid #dceaea;
}

.labelText {
  color: #1dd8f6;
}

.userDetails {
  width: 100%;
}

.userDetails .col:first-child {
  border-right: 1px solid #fdf7f7;
  padding-right: 20px;
}

.userDetails .col:last-child {
  padding-left: 20px;
}

.addBtn {
  border: 1px solid #dceaea;
  border-radius: 5px;
  padding: 7px 15px;
  color: #6a6a6a;
  width: 90px;
  text-align: center;
}

.selectListItems {
  width: calc(100% - 120px);
  margin-right: 30px;
}

.selectedItem {
  color: #6a6a6a;
  margin-top: 30px;
}

#volumeLevel {
  height: 30px !important;
}

.selectedItem>img {
  margin-right: 15px;
}

.clearSelectedItems {
  color: #f27778;
  text-decoration: underline;
  padding-top: 30px;
}

.deviceDataWrapper .contentData.expanded {
  height: 140px;
}

.additionalInfo {
  display: flex;
  position: relative;
  padding: 5px 0;
}

.btnExport {
  background: #50b9d4;
  border-radius: 20px;
  color: #fff;
  float: right;
  padding: 5px 25px;
  width: 100px;
  text-align: center;
  border: none;
}

#visitorPropertiesModal .modal-dialog {
  //width: 600px;
  //height: 600px;
  max-width: 90% !important;
}

#provisionModal .modal-dialog {
  //width: 600px;
  //height: 600px;
  max-width: 50% !important;
}

#visitorPropertiesModal td {
  text-transform: capitalize;
  padding: 5px;
}

#visitorPropertiesModal tr.visit-headings td {
  font-weight: bold;
  color: #1a80a8;
  padding: 5px;
}

#visitorPropertiesModal tr td.mapping {
  min-width: 200px;
}

#visitorPropertiesModal tr td.mapping .selectDD {
  width: 200px !important;
}

#visitorPropertiesModal tr td.question {
  min-width: 350px;
}

#visitorPropertiesModal tr td input[type="text"] {
  text-overflow: ellipsis;
}

#visitorPropertiesModal tr td select {
  width: 130px !important;
  overflow: hidden !important;
  white-space: nowrap;
  text-overflow: ellipsis;
  border: 1px solid #dceaea;
  outline: none;
  padding: 7px 15px;
  border-radius: 5px;
  color: #6a6a6a;
}

@media (max-width: 1919px) {
  .dashboardBlock {
    padding: 15px;
  }

  .dashboardIcon {
    margin-right: 10px;
  }

  .dashboardIcon>img {
    width: 22px;
  }

  .dashboardNumber {
    font-size: 36px;
  }

  .dashboardNumber>span {
    font-size: 12px;
    display: block;
  }

  .facilityInfo .dashboardNumber {
    padding: 0 13px;
    font-size: 36px;
  }

  .facilityName {
    font-size: 14px;
  }

  .infoWrapper {
    padding: 10px;
  }

  .facilityInfoWrapper {
    overflow: auto;
    max-height: calc(100vh - 220px);
  }

  .pageHeader {
    font-size: 20px;
  }

  .userContentWrapper .contentData>div:nth-child(2) .text-right {
    text-align: left !important;
  }

  .tenantOption {
    color: #6a6a6a;
    padding: 10px;
  }

  .filterInputText {
    max-width: 215px !important;
    background: rgba(255, 255, 255, 0.5) !important;
    color: #fff !important;
    padding: 0 0 0 4px !important;
  }
}

.filterInputText {
  max-width: 215px !important;
  background: #575757 !important;
  outline: none !important;
  border: 1px solid #575757 !important;
  //background: rgba(255,255,255,0.5) !important;
  color: #fff !important;
  padding: 1px 15px;
}

.custom-control,
.col-form-label,
.modal-title,
.modal-footer,
.form-control {
  font-family: "GTWalsheimPro-Regular" !important;
}

.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
  overflow-x: hidden;
  overflow-y: auto;

  &__backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 1;
    font-family: "GTWalsheimPro-Regular" !important;
  }

  &__dialog {
    position: relative;
    width: 600px;
    background-color: #ffffff;
    border-radius: 5px;
    margin: 50px auto;
    display: flex;
    flex-direction: column;
    z-index: 2;

    @media screen and (max-width: 992px) {
      width: 90%;
    }
  }

  &__close {
    width: 30px;
    height: 30px;
  }

  &__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 20px 20px 10px;
  }

  &__body {
    padding: 10px 20px 10px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  &__footer {
    padding: 10px 20px 20px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

body select {
  width: 100% !important;
  overflow: hidden !important;
  white-space: nowrap;
  text-overflow: ellipsis;
  height:36px;
}

body select option {
  width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
  // background: rgba(0, 0, 0, 0.3);
  color: #6a6a6a;
}

body select {
  width: 100% !important;
  overflow: hidden !important;
  white-space: nowrap;
  text-overflow: ellipsis;
  height:36px;
}

.ui.selection.dropdown{
  color: #fff;
}
.full{
  width:100%;
}

::v-deep .ui.selection.dropdown .menu .item{
  overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    // max-width: 334px;
    margin: 0px 10px 2px;
    padding: 10px 7px !important;
    border-radius: 5px;
    border: none;
}
::v-deep .ui.dropdown .menu>.item:hover{
  color:#1dd8f6;
  background:#EAF9FF !important;
}
::v-deep .ui.dropdown .menu>.item.selected{
  color:#1dd8f6;
  background:#fff;
}

::v-deep #addDeviceOperationsModal .modal-dialog .modal-content{
  border: none !important;
  -webkit-box-shadow: 0px 0px 33px -11px rgba(17, 30, 54, 1);
  -moz-box-shadow: 0px 0px 33px -11px rgba(17, 30, 54, 1);
  box-shadow: 0px 0px 33px -11px rgba(17, 30, 54, 1);
}

::v-deep #addDeviceOperationsModal .modal-dialog{
    max-width: 420px;
}
body #addDeviceOperationsModal select {
width: 100% !important;
} 
body #addDeviceOperationsModal .mx-datepicker {
width: 100% !important;
} 

::v-deep #addDeviceOperationsModal .modal-dialog label{
    color: #3288d2;
    font-family: GTWalsheimPro-Regular !important;
    font-size: 16px;
    font-weight: 400;
}

::v-deep #addModal___BV_modal_body_ label{
  color:#3288D2;
  font-size:15px;
}
::v-deep #addModal___BV_modal_body_ label.custom-control-label{
  color:#484848;
}

@media (max-width: 1746px) {
  .devicesPageHeader .filterWrapper {
    min-width: 41%;
  }
}

@media (max-width: 1680px) {
  .devicesPageHeader .filterWrapper {
    min-width: 40%;
  }
}

@media (max-width: 1600px) {
  .devicesPageHeader .filterWrapper {
    min-width: 37%;
  }
}

@media (max-width: 1536px) {
  .devicesPageHeader .filterWrapper {
    margin-left: 10px;
    min-width: 37%;
  }
}

@media (max-width: 1440px) {
  .devicesPageHeader>.col-7 {
    -ms-flex: 0 0 55.333333%;
    flex: 0 0 55.333333%;
    max-width: 55.333333%;
  }
}

@media (max-width: 1400px) {
  .devicesPageHeader>.col-7 {
    -ms-flex: 0 0 54.333333%;
    flex: 0 0 54.333333%;
    max-width: 54.333333%;
  }
}

@media (max-width: 1366px) {
  .devicesPageHeader>.col-7 {
    -ms-flex: 0 0 53.333333%;
    flex: 0 0 53.333333%;
    max-width: 53.333333%;
  }
}

@media (max-width: 1360px) {
  .devicesPageHeader>.col-7 {
    -ms-flex: 0 0 52.333333%;
    flex: 0 0 52.333333%;
    max-width: 52.333333%;
  }
}
 .contentDataWrapper h3 {
  padding: 20px 20px 0;
  color: #1a80a8;
  font-size: 24px;
  font-family: "GTWalsheimPro-Regular";
  font-weight: 400;
}
</style>
